import * as React from "react";
import wrapIcon from "../utils/wrapIcon";
const CheckmarkCircleLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 10-8 8v-3a5 5 0 017.94-4.04c.04-.32.06-.64.06-.96zm-5.28-2.41a.5.5 0 01.7.7l-.06.06-4 4-.08.07a.5.5 0 01-.56 0l-.07-.06-2-2-.06-.07a.5.5 0 01.7-.7l.06.06L9 11.3l3.65-3.65.07-.06z",
    fill: primaryFill
  }));
};
export const CheckmarkCircleLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkCircleLoopFilledIcon({}), 'CheckmarkCircleLoopFilled');
const BingColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 1.75c0-.6.66-.95 1.16-.62L8.1 2.4A2 2 0 019 4.08V16H6.5L5 13.75v-12z",
    fill: "url(#paint0_linear_1_57)"
  }), React.createElement("path", {
    d: "M5 1.75c0-.6.66-.95 1.16-.62L8.1 2.4A2 2 0 019 4.08V16H6.5L5 13.75v-12z",
    fill: "url(#paint1_linear_1_57)"
  }), React.createElement("path", {
    d: "M6.58 14.93l-.04-.01A2.94 2.94 0 015 13.5 4.5 4.5 0 009.5 18h.06c.94 0 1.85-.29 2.62-.82l2.98-2.1c.53-.36.84-.96.84-1.6v-.81a1.17 1.17 0 00-1.78-1L9.3 14.7c-.83.5-1.84.59-2.73.23z",
    fill: "url(#paint2_linear_1_57)"
  }), React.createElement("path", {
    d: "M6.58 14.93l-.04-.01A2.94 2.94 0 015 13.5 4.5 4.5 0 009.5 18h.06c.94 0 1.85-.29 2.62-.82l2.98-2.1c.53-.36.84-.96.84-1.6v-.81a1.17 1.17 0 00-1.78-1L9.3 14.7c-.83.5-1.84.59-2.73.23z",
    fill: "url(#paint3_linear_1_57)"
  }), React.createElement("path", {
    d: "M10.72 9.59l-.68-2.26a.8.8 0 011.16-.92l3.62 2.11a3.93 3.93 0 01.6 6.36l-.06.06-.36.26a1.98 1.98 0 00-.54-3.4l-2.56-.96c-.57-.22-1-.68-1.18-1.25z",
    fill: "url(#paint4_linear_1_57)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_1_57",
    x1: 11.99,
    y1: 16.16,
    x2: 11.99,
    y2: 1.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#1B48EF"
  }), React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1C51F0"
  }), React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1E69F5"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2190FB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#26B8F4"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_1_57",
    x1: 11.99,
    y1: 0.99,
    x2: 11.99,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "paint2_linear_1_57",
    x1: 5,
    y1: 14.74,
    x2: 16,
    y2: 14.74,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#39D2FF"
  }), React.createElement("stop", {
    offset: 0.15,
    stopColor: "#38CEFE"
  }), React.createElement("stop", {
    offset: 0.29,
    stopColor: "#35C3FA"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2FB0F3"
  }), React.createElement("stop", {
    offset: 0.55,
    stopColor: "#299AEB"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2692EC"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1A6CF1"
  }), React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1355F4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#104CF5"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_1_57",
    x1: 6.27,
    y1: 16.98,
    x2: 14.24,
    y2: 11.55,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), React.createElement("linearGradient", {
    id: "paint4_linear_1_57",
    x1: 9.06,
    y1: 8.11,
    x2: 16.77,
    y2: 12.58,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#37BDFF"
  }), React.createElement("stop", {
    offset: 0.18,
    stopColor: "#33BFFD"
  }), React.createElement("stop", {
    offset: 0.36,
    stopColor: "#28C5F5"
  }), React.createElement("stop", {
    offset: 0.53,
    stopColor: "#15D0E9"
  }), React.createElement("stop", {
    offset: 0.55,
    stopColor: "#12D1E7"
  }), React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1CD2E5"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#42D8DC"
  }), React.createElement("stop", {
    offset: 0.91,
    stopColor: "#59DBD6"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#62DCD4"
  }))));
};
export const BingColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/BingColorIcon({}), 'BingColor');
const BingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 1.75c0-.6.66-.95 1.16-.62L8.1 2.4A2 2 0 019 4.08v9.63l-.6.36A2.25 2.25 0 015 12.2V1.75zm5.54 12.2l-1.2.73-.11.06-.3.19a3.24 3.24 0 01-3.8-.32A4.5 4.5 0 009.5 18h.06c.87 0 1.71-.25 2.44-.7l2.25-1.58c1.16-.82.93-2.6-.4-3.08l-.75-.28-2.46 1.51a.5.5 0 01-.1.08zm3.64-2.25h.01a2.73 2.73 0 011.8 2.52 3.9 3.9 0 00-1.16-5.69l-3.62-2.12a.77.77 0 00-1.13.88l.65 2.28c.17.58.6 1.06 1.18 1.27l2.27.85z",
    fill: primaryFill
  }));
};
export const BingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BingFilledIcon({}), 'BingFilled');
const BingMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 1.75c0-.6.66-.95 1.16-.62L8.1 2.4A2 2 0 019 4.08v10.78l.3-.16 4.88-3-2.27-.86c-.57-.21-1-.69-1.18-1.27l-.65-2.28a.77.77 0 011.13-.88l3.62 2.12a3.9 3.9 0 01.73 6.18c-.11.14-.25.27-.4.38l-2.98 2.09c-.77.53-1.68.82-2.62.82H9.5A4.5 4.5 0 015 13.76V1.75z",
    fill: primaryFill
  }));
};
export const BingMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/BingMonoIcon({}), 'BingMono');
const BingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2.25V12.8a2.25 2.25 0 003 2.06V4.2a.75.75 0 00-.33-.62L5.39 2.04a.25.25 0 00-.39.21zm-1 0c0-1 1.12-1.6 1.95-1.03l2.28 1.53c.48.33.77.87.77 1.45v10.11l3.55-2.14-.73-.26a1.25 1.25 0 01-.77-.83l-1-3.48a1.25 1.25 0 011.83-1.43l1.33.77a.5.5 0 01.04.02l1.07.62a5.36 5.36 0 01.5 8.96l-.03.02-.07.05-.97.68-.98.69A5.57 5.57 0 014 13.42v-.61V10.34a.5.5 0 010-.04V2.25zm10.43 13.33a1.75 1.75 0 00-.6-2.94l-.07-.03-4.83 2.91c-1.15.7-2.47.58-3.46-.06a4.58 4.58 0 006.72 1.7l.08-.05.02-.02 1.92-1.34.22-.17zm1.42-2.2a4.36 4.36 0 00-1.97-4.9l-2.5-1.44a.25.25 0 00-.37.28l1 3.48c.02.08.08.14.15.17h.03a.5.5 0 01.07.03l1.93.7c.84.3 1.4.94 1.66 1.68z",
    fill: primaryFill
  }));
};
export const BingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BingRegularIcon({}), 'BingRegular');
const BookingsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2H5.87a.95.95 0 00-.6.2.76.76 0 00-.2.25.69.69 0 00-.07.29v14.53c0 .2.1.39.26.52.16.14.38.21.6.21H9V2z",
    fill: "#057093"
  }), React.createElement("path", {
    d: "M12 2H8.87a.95.95 0 00-.6.2.76.76 0 00-.2.25.69.69 0 00-.07.29v14.53c0 .1.03.2.07.29a.86.86 0 00.47.4c.1.03.21.04.32.04H12V2z",
    fill: "#1098B6"
  }), React.createElement("path", {
    d: "M18 2.74a.8.8 0 00-.19-.52.6.6 0 00-.46-.22h-5.7a.6.6 0 00-.46.22.8.8 0 00-.19.52v14.53c0 .1.02.2.05.28.03.09.08.17.14.24.06.06.13.12.2.15.08.04.16.06.25.06h5.72a.64.64 0 00.45-.21.82.82 0 00.19-.52V2.74z",
    fill: "#30CCD7"
  }), React.createElement("path", {
    d: "M18 7h-7v6h7V7z",
    fill: "#70ECEE"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M11.94 6H5v10h6.73c.32 0 .62-.11.85-.29.23-.17.38-.42.42-.68v-8.2a.72.72 0 00-.08-.33.85.85 0 00-.23-.27c-.1-.08-.22-.14-.35-.18a1.18 1.18 0 00-.4-.05z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11.17 5H2.83a.83.83 0 00-.83.83v8.34c0 .46.37.83.83.83h8.34c.46 0 .83-.37.83-.83V5.83a.83.83 0 00-.83-.83z",
    fill: "#057093"
  }), React.createElement("path", {
    d: "M8.67 7.17c.3.1.57.26.78.49.17.2.27.46.27.73 0 .31-.11.62-.34.87-.24.26-.57.44-.94.52.29.03.57.11.82.25.23.12.42.3.55.5a1.52 1.52 0 01-.11 1.63c-.22.27-.52.49-.87.62-.4.15-.84.23-1.28.22H5V7h2.5c.4 0 .8.05 1.17.17zm-1.5 2.3c.3.01.6-.07.84-.23.1-.08.18-.17.23-.28.05-.1.08-.22.07-.34 0-.48-.38-.72-1.14-.72h-.84v1.56h.84zm-.84 2.64h1.04c.33.03.67-.05.94-.23.1-.08.19-.18.25-.3a.75.75 0 00.08-.36.66.66 0 00-.08-.35.76.76 0 00-.26-.28c-.28-.16-.6-.24-.94-.22H6.33v1.74z",
    fill: "#fff"
  }));
};
export const BookingsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/BookingsColorIcon({}), 'BookingsColor');
const BookingsMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a1 1 0 011-1h11a1 1 0 011 1v14a1 1 0 01-1 1H6a1 1 0 01-1-1v-2H2.83a.83.83 0 01-.83-.83V5.83c0-.46.37-.83.83-.83H5V3zm1 14h2v-2H6v2zm3 0h2v-2H9v2zM9 5h2V3H9v2zm3 1h5V3h-5v3zm0 7h5V7h-5v6zm0 1v3h5v-3h-5zM6 5h2V3H6v2zm3.45 2.66c-.2-.23-.48-.4-.78-.5A3.7 3.7 0 007.5 7H5v6h2.55c.44 0 .88-.07 1.28-.22.35-.13.65-.35.87-.62a1.52 1.52 0 00.11-1.62c-.13-.21-.32-.39-.55-.51a2.05 2.05 0 00-.82-.25c.37-.08.7-.26.94-.52.23-.25.35-.56.34-.87 0-.27-.1-.52-.27-.73zM8 9.24c-.24.16-.54.24-.84.22h-.84V7.9h.84c.76 0 1.14.24 1.14.72 0 .12-.02.23-.07.34-.05.1-.13.2-.23.28zm-.64 2.87H6.33v-1.74h1.03c.33-.02.66.06.94.22.11.08.2.17.26.28.06.11.08.23.08.35 0 .13-.03.25-.08.36a.85.85 0 01-.25.3c-.27.18-.6.26-.94.23z",
    fill: primaryFill
  }));
};
export const BookingsMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/BookingsMonoIcon({}), 'BookingsMono');
const BrandEdgeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "a"
  }, React.createElement("stop", {
    stopColor: "#094987",
    offset: "0%"
  }), React.createElement("stop", {
    stopColor: "#0C59A4",
    offset: "24.5%"
  }), React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "100%"
  })), React.createElement("linearGradient", {
    x1: "47.1%",
    y1: "1.49%",
    x2: "33.27%",
    y2: "83.18%",
    id: "b"
  }, React.createElement("stop", {
    stopColor: "#117FBA",
    offset: "0%"
  }), React.createElement("stop", {
    stopColor: "#1797E0",
    offset: "22.34%"
  }), React.createElement("stop", {
    stopColor: "#0078D4",
    offset: "94.79%"
  })), React.createElement("linearGradient", {
    x1: "100%",
    y1: "54.46%",
    x2: "30%",
    y2: "39.47%",
    id: "c"
  }, React.createElement("stop", {
    stopColor: "#48D566",
    offset: "0%"
  }), React.createElement("stop", {
    stopColor: "#35C1F1",
    offset: "100%"
  }))), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M16.44 13.9a6.38 6.38 0 01-2.9.7C10.58 14.6 8 12.58 8 9.97c0-.73.43-1.37 1.03-1.7-2.67.1-3.36 2.9-3.36 4.53 0 4.62 4.25 5.09 5.17 5.09a6.71 6.71 0 001.77-.32 8.02 8.02 0 004.16-3.3c.14-.22-.1-.47-.33-.35z",
    fill: "url(#a)"
  }), React.createElement("path", {
    d: "M8.6 17.09a5.1 5.1 0 01.42-8.83c.2-.1.54-.26.98-.26a2.02 2.02 0 012 1.98c0-.01 1.53-4.97-5-4.97-2.74 0-5 2.6-5 4.88a8.02 8.02 0 0010.53 7.7 4.74 4.74 0 01-3.92-.5z",
    fill: "url(#b)"
  }), React.createElement("path", {
    d: "M11.52 11.3c-.05.07-.2.16-.2.36 0 .16.1.32.29.45.9.63 2.6.54 2.6.54a3.72 3.72 0 002.6-1.05A3.86 3.86 0 0018 8.82c.02-1.4-.5-2.33-.7-2.74C15.96 3.49 13.1 2 10 2a8 8 0 00-8 7.89c.03-2.29 2.3-4.13 5-4.13.22 0 1.46.02 2.62.63a4.53 4.53 0 011.93 1.82c.39.67.46 1.51.46 1.85 0 .34-.17.83-.49 1.24z",
    fill: "url(#c)"
  })));
};
export const BrandEdgeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandEdgeColorIcon({}), 'BrandEdgeColor');
const BrandEdgeMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.78 3.17A7.64 7.64 0 019.97 2C15.22 2 18 5.87 18 8.86a3.89 3.89 0 01-3.83 3.88c-2.35 0-2.86-.72-2.86-1 0-.13.08-.21.18-.33l.04-.05c.3-.36.47-.82.47-1.3C12 7.6 9.43 5.6 6.25 5.6a6.9 6.9 0 00-3.36.84 7.73 7.73 0 012.9-3.27zm3.54 5l.11-.04a5.2 5.2 0 00-3.18-1.02C3.95 7.11 2 8.46 2 10.06c0 1.89.66 3.7 1.85 5.15A8.03 8.03 0 008.52 18a5.83 5.83 0 01-2.28-4.89c0-2.08 1.47-4.39 3.08-4.94zm7.34 6.36l.02-.03c.1-.16.2-.3.05-.46-.12-.12-.24-.07-.36 0l-.06.03c-.88.43-1.85.65-2.82.64a5.58 5.58 0 01-5.28-3.42c-.3.56-.46 1.19-.47 1.82a4.21 4.21 0 002.52 4.17c.53.23 1.1.34 1.68.33a5.89 5.89 0 003.4-1.56c.51-.45.95-.96 1.32-1.52z",
    fill: primaryFill,
    fillRule: "nonzero"
  }));
};
export const BrandEdgeMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandEdgeMonoIcon({}), 'BrandEdgeMono');
const BrandToDoColorFallbackIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.37 6.98L1.32 9.03a1.04 1.04 0 000 1.5l3.66 3.55 3.55-3.55-3.55-3.55a1.17 1.17 0 00-1.61 0z",
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M17.68 5.47l-2.05-2.15a1.04 1.04 0 00-1.5 0l-2.8 2.8-3.55 3.66-2.8 2.8a1.04 1.04 0 000 1.5l2.05 2.05c.43.43 1.07.43 1.5 0l2.8-2.8 3.55-3.55 2.8-2.8c.43-.43.43-1.18 0-1.5z",
    fill: "#2A88E5"
  }));
};
export const BrandToDoColorFallback = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandToDoColorFallbackIcon({}), 'BrandToDoColorFallback');
const BrandToDoColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.37 6.98L1.32 9.03a1.04 1.04 0 000 1.5l3.66 3.55 3.55-3.55-3.55-3.55a1.17 1.17 0 00-1.61 0z",
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M17.68 5.47l-2.05-2.15a1.04 1.04 0 00-1.5 0l-2.8 2.8-3.55 3.66-2.8 2.8a1.04 1.04 0 000 1.5l2.05 2.05c.43.43 1.07.43 1.5 0l2.8-2.8 3.55-3.55 2.8-2.8c.43-.43.43-1.18 0-1.5z",
    fill: "url(#paint0_linear)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.1,
    y1: -0.73,
    x2: 0.93,
    y2: 9.81,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#62C4F6"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2A88E5"
  }))));
};
export const BrandToDoColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandToDoColorIcon({}), 'BrandToDoColor');
const BrandToDoMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.67 5.29l-2.01-1.97a1.05 1.05 0 00-1.51 0l-2.77 2.72L7.86 9.6 5.84 7.5a1.05 1.05 0 00-1.52 0l-2 2.1a1.05 1.05 0 000 1.5l2.77 2.77 2.02 2a1.05 1.05 0 001.5 0l9.06-9.07a1.05 1.05 0 000-1.51zM5.12 12.35l-2.03-2.1 2-1.96L7.1 10.3l-2 2.03h.02zm5.57 0l-2.85 2.77-1.57-1.58-.45-.46L8.6 10.3l3.51-3.53 2.77-2.77 2.03 2.1-6.22 6.24z",
    fill: primaryFill
  }));
};
export const BrandToDoMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandToDoMonoIcon({}), 'BrandToDoMono');
const BrandYourPhoneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 7C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8C2 7.67 2.67 7 3.5 7h4zM6 15H5a.5.5 0 000 1h1a.5.5 0 000-1zm11.5-1a.5.5 0 01.09 1H10v-1h7.5zm-2-11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10V8a2 2 0 00-2-2H3V4.5C3 3.67 3.67 3 4.5 3h11z",
    fill: primaryFill,
    fillRule: "nonzero"
  }));
};
export const BrandYourPhoneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandYourPhoneFilledIcon({}), 'BrandYourPhoneFilled');
const BrandYourPhoneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 7C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8C2 7.67 2.67 7 3.5 7h4zm0 1h-4a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5zM6 15a.5.5 0 01.09 1H5a.5.5 0 01-.09-1H6zm11.5-1a.5.5 0 01.09 1H10v-1h7.5zm-2-11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10v-1h5.5a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5V6H3V4.5C3 3.67 3.67 3 4.5 3h11z",
    fill: primaryFill,
    fillRule: "nonzero"
  }));
};
export const BrandYourPhoneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandYourPhoneRegularIcon({}), 'BrandYourPhoneRegular');
const BrandYoutubeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.67 5.87a2.08 2.08 0 00-1.42-1.51C15 4 10 4 10 4s-5 0-6.25.36c-.69.2-1.23.78-1.42 1.51C2 7.21 2 10 2 10s0 2.79.33 4.13c.19.73.73 1.31 1.42 1.51C5 16 10 16 10 16s5 0 6.25-.36c.69-.2 1.23-.78 1.42-1.51C18 12.79 18 10 18 10s0-2.79-.33-4.13zm-9.3 6.66V7.47L12.54 10l-4.19 2.53z",
    fill: "red"
  }));
};
export const BrandYoutubeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandYoutubeColorIcon({}), 'BrandYoutubeColor');
const BrandYoutubeMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.67 5.87a2.08 2.08 0 00-1.42-1.51C15 4 10 4 10 4s-5 0-6.25.36c-.69.2-1.23.78-1.42 1.51C2 7.21 2 10 2 10s0 2.79.33 4.13c.19.73.73 1.31 1.42 1.51C5 16 10 16 10 16s5 0 6.25-.36c.69-.2 1.23-.78 1.42-1.51C18 12.79 18 10 18 10s0-2.79-.33-4.13zm-9.3 6.66V7.47L12.54 10l-4.19 2.53z",
    fill: primaryFill
  }));
};
export const BrandYoutubeMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrandYoutubeMonoIcon({}), 'BrandYoutubeMono');
const CalendarAgendaLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M15 10c.71 0 1.39.15 2 .41V5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17H10v-2c0-.34.04-.68.1-1H6.41a.5.5 0 010-1h4.01a5.02 5.02 0 012.4-2.5H6.41a.5.5 0 010-1h7.18a.5.5 0 01.4.6c.33-.06.67-.1 1.01-.1zm-1-3.5a.5.5 0 01-.41.5H6.5a.5.5 0 01-.09-1h7.09a.5.5 0 01.5.5z",
    fill: primaryFill
  }));
};
export const CalendarAgendaLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgendaLoopFilledIcon({}), 'CalendarAgendaLoopFilled');
const CalendarTodoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v1.59a2 2 0 00-1.48.58l-3.88 3.9-.36-.36a2 2 0 00-2.83 0L7.4 13.77a2 2 0 000 2.83l.4.4H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM8.1 14.48a1 1 0 000 1.41l2.83 2.83a1 1 0 001.41 0l6.37-6.36a1 1 0 000-1.42l-1.06-1.06a1 1 0 00-1.42 0l-4.6 4.6-1.06-1.06a1 1 0 00-1.4 0L8.1 14.48zM11.64 18l-1.07-1.06 6.37-6.36L18 11.65 11.64 18zm-.71-2.83l-1.06 1.06-1.06-1.06 1.06-1.06 1.06 1.06z",
    fill: primaryFill
  }));
};
export const CalendarTodoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTodoFilledIcon({}), 'CalendarTodoFilled');
const CalendarTodoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v3.09a2 2 0 00-1 .23V7H4v7.5c0 .83.67 1.5 1.5 1.5h1.48a2 2 0 00.41.6l.4.4H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM8.1 15.9a1 1 0 010-1.42l1.06-1.06a1 1 0 011.41 0l1.07 1.06 4.6-4.6a1 1 0 011.4 0l1.07 1.06a1 1 0 010 1.42l-6.37 6.36a1 1 0 01-1.41 0L8.1 15.89zm2.47 1.05l1.07 1.06L18 11.65l-1.06-1.06-6.37 6.36zm-1.76-1.77l1.06 1.06 1.06-1.06-1.06-1.06-1.06 1.06z",
    fill: primaryFill
  }));
};
export const CalendarTodoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTodoRegularIcon({}), 'CalendarTodoRegular');
const ClipboardTextLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.6a5.03 5.03 0 00-5.9 3.9H6.5a.5.5 0 000 1H10v3H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zm4.91.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zM13.5 8h-7a.5.5 0 000 1h7a.5.5 0 000-1zM10 11.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};
export const ClipboardTextLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextLoopFilledIcon({}), 'ClipboardTextLoopFilled');
const ClipboardTextLtrLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.6a5.03 5.03 0 00-5.9 3.9H6.5a.5.5 0 000 1H10v3H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zm4.91.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zM13.5 8h-7a.5.5 0 000 1h7a.5.5 0 000-1zM10 11.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};
export const ClipboardTextLtrLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextLtrLoopFilledIcon({}), 'ClipboardTextLtrLoopFilled');
const ClipchampColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.14 1.19L2 4.45c-.7.16-1.13.86-.97 1.55l.37 1.63c.16.7.86 1.13 1.55.97L17.1 5.33c.7-.16 1.13-.85.97-1.55l-.38-1.63a1.29 1.29 0 00-1.55-.96z",
    fill: "url(#paint0_linear_49763_191461)"
  }), React.createElement("path", {
    d: "M13 7h4.25c.97 0 1.75.78 1.75 1.75V11h-6V7z",
    fill: "#AA72E1"
  }), React.createElement("path", {
    d: "M1 15h18v2.25c0 .97-.78 1.75-1.75 1.75H2.75C1.78 19 1 18.22 1 17.25V15z",
    fill: "#5A4CDB"
  }), React.createElement("path", {
    d: "M7 11H1v4h6v-4z",
    fill: "#AA72E1"
  }), React.createElement("path", {
    d: "M19 11H7v4h12v-4z",
    fill: "#885EDE"
  }), React.createElement("path", {
    d: "M13 7H1v4h12V7z",
    fill: "#C689E6"
  }), React.createElement("path", {
    d: "M1 13.71V15h1.29A1.3 1.3 0 011 13.71z",
    fill: "#5A4CDB"
  }), React.createElement("path", {
    d: "M1 9.71V11h1.29A1.3 1.3 0 011 9.71z",
    fill: "#AA72E1"
  }), React.createElement("path", {
    d: "M1 5.71V7h1.29A1.3 1.3 0 011 5.71z",
    fill: "#C689E6"
  }), React.createElement("path", {
    d: "M17.25 7H2.28A1.3 1.3 0 011 5.71v11.54c0 .97.78 1.75 1.75 1.75h14.5c.97 0 1.75-.78 1.75-1.75v-8.5C19 7.78 18.22 7 17.25 7z",
    fill: "url(#paint1_linear_49763_191461)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_49763_191461",
    x1: 0.74,
    y1: 4.74,
    x2: 11.57,
    y2: 13.47,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5A4CDB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AD58DB"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_49763_191461",
    x1: 1,
    y1: 5.71,
    x2: 21.02,
    y2: 14.29,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FCCEF5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4CDB"
  }))));
};
export const ClipchampColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipchampColorIcon({}), 'ClipchampColor');
const ClipchampMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.75 6h-6.67l6.74-1.31a1.52 1.52 0 001.19-1.76l-.22-1.13A1.52 1.52 0 0016.03.61L2.54 3.24A1.9 1.9 0 001 5.1v11.65A2.25 2.25 0 003.25 19h13.5A2.25 2.25 0 0019 16.75v-8.5A2.25 2.25 0 0016.75 6zM2 10.62c.36.24.79.38 1.25.38H7v3H3.25C2.56 14 2 13.44 2 12.75v-2.13zM3.25 10C2.56 10 2 9.44 2 8.75V6.6c.36.25.78.4 1.25.4H12v3H3.25zM18 16.75c0 .69-.56 1.25-1.25 1.25H3.25C2.56 18 2 17.44 2 16.75v-2.13c.36.24.79.38 1.25.38H18v1.75zM18 14H8v-3h10v3zm0-4h-5V7h3.75c.69 0 1.25.56 1.25 1.25V10z",
    fill: primaryFill
  }));
};
export const ClipchampMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipchampMonoIcon({}), 'ClipchampMono');
const ComponentLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v7a3 3 0 003 3h4v-2.5a5.5 5.5 0 019-4.24V7a3 3 0 00-3-3H5zm9 3a1 1 0 11-2 0 1 1 0 012 0zm-4 1a1 1 0 110-2 1 1 0 010 2zM8 7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};
export const ComponentLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ComponentLoopFilledIcon({}), 'ComponentLoopFilled');
const ComponentLoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v3.26a5.5 5.5 0 00-1-.66V7a2 2 0 00-2-2H5a2 2 0 00-2 2v7c0 1.1.9 2 2 2h4v1H5a3 3 0 01-3-3V7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14 7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10 8a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};
export const ComponentLoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ComponentLoopRegularIcon({}), 'ComponentLoopRegular');
const CopilotColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 3.35A1.88 1.88 0 0012.34 2h-.6c-.9 0-1.66.63-1.84 1.51L8.85 8.85l.3-.96c.24-.78.97-1.32 1.8-1.32h3.29l1.4 1.17 1.24-1.17h-.39c-.83 0-1.57-.55-1.8-1.35l-.55-1.87z",
    fill: "url(#paint0_radial_56201_15523)"
  }), React.createElement("path", {
    d: "M6.05 16.64c.23.8.97 1.36 1.8 1.36h1.22c1.01 0 1.84-.8 1.88-1.8l.18-5.06-.29.96c-.24.79-.97 1.33-1.8 1.33h-3.3l-1.39-.89-1.02.89h.38c.84 0 1.57.55 1.8 1.36l.54 1.85z",
    fill: "url(#paint1_radial_56201_15523)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint2_linear_56201_15523)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint3_linear_56201_15523)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint4_radial_56201_15523)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint5_linear_56201_15523)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_56201_15523",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-129.14 9.97 .71) scale(7.20751 6.76953)"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00AEFF"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_56201_15523",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(51.73 -11.45 11.6) scale(6.58647 6.39483)"
  }, React.createElement("stop", {
    stopColor: "#FFB657"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF5F3D"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C02B3C"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_56201_15523",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.18437 14.3365 -17.62744 -6.37443 17.09 5.45)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB152"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_56201_15523",
    x1: 5.3,
    y1: 3.39,
    x2: 6.17,
    y2: 13.87,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0D91E1"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#52B471"
  }), React.createElement("stop", {
    offset: 0.65,
    stopColor: "#98BD42"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFC800"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_56201_15523",
    x1: 6.11,
    y1: 2,
    x2: 6.59,
    y2: 13.44,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint5_linear_56201_15523",
    x1: 17.6,
    y1: 5.87,
    x2: 17.6,
    y2: 8.99,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F8ADFA"
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#A86EDD",
    stopOpacity: 0
  }))));
};
export const CopilotColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotColorIcon({}), 'CopilotColor');
const CopilotFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.93 2h6.2c1.06 0 1.99.7 2.29 1.7l.47 1.6c.16.55.64.93 1.2.98h.28c.9 0 1.58.25 2.03.77.44.5.6 1.17.6 1.84.02 1.32-.5 2.96-.9 4.27a12.57 12.57 0 01-1.45 3.22c-.61.9-1.45 1.62-2.58 1.62H7.86c-1.05 0-1.98-.7-2.28-1.7l-.47-1.6a1.38 1.38 0 00-1.2-.98h-.29c-.88 0-1.57-.25-2.02-.77a2.78 2.78 0 01-.6-1.84c-.02-1.32.5-2.96.9-4.26.37-1.14.83-2.32 1.44-3.23C3.96 2.72 4.8 2 5.93 2zm-.2 11.72c.15.2.27.44.34.7l.47 1.6c.17.58.71.98 1.32.98h.03c.36 0 .6-.17.75-.38a4 4 0 00.47-.95c.15-.4.29-.83.44-1.33l.03-.1.2-.64c-.24.07-.49.11-.74.11H6.4l-.16.01h-.52zm2.46-1h.85c.55 0 1.04-.34 1.26-.84l1.17-3.9c.07-.25.19-.49.34-.7h-.85c-.55 0-1.04.34-1.26.83l-1.17 3.91c-.08.25-.19.49-.34.7zm2.03-6.32c.24-.07.49-.11.74-.11h3.3c-.14-.22-.26-.45-.33-.7l-.47-1.6c-.17-.59-.71-.99-1.32-.99h-.02a.92.92 0 00-.76.38 4 4 0 00-.48.96c-.14.38-.28.82-.43 1.32l-.03.1-.2.64z",
    fill: primaryFill
  }));
};
export const CopilotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotFilledIcon({}), 'CopilotFilled');
const CopilotRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.93 2h6.2c1.06 0 1.99.7 2.29 1.7l.47 1.6c.16.55.64.93 1.2.98h.28c.9 0 1.58.25 2.03.77.44.5.6 1.17.6 1.84.02 1.32-.5 2.96-.9 4.27a12.57 12.57 0 01-1.45 3.22c-.61.9-1.45 1.62-2.58 1.62H7.86c-1.05 0-1.98-.7-2.28-1.7l-.47-1.6a1.38 1.38 0 00-1.2-.98h-.29c-.88 0-1.57-.25-2.02-.77a2.78 2.78 0 01-.6-1.84c-.02-1.32.5-2.96.9-4.26.37-1.14.83-2.32 1.44-3.23C3.96 2.72 4.8 2 5.93 2zM2.86 7.15C2.43 8.5 1.98 9.97 2 11.1c0 .55.13.94.35 1.2.2.23.57.42 1.27.42h2.63c.61 0 1.15-.4 1.32-.98.47-1.58 1.27-4.24 1.9-6.28l.03-.1c.15-.5.3-.96.45-1.38.13-.35.28-.69.46-.98H5.93c-.65 0-1.22.4-1.76 1.19-.53.78-.96 1.84-1.3 2.96zm2.87 6.57c.15.2.27.44.34.7l.47 1.6c.17.58.71.98 1.32.98h.03c.36 0 .6-.17.75-.38a4 4 0 00.47-.95c.15-.4.29-.83.44-1.33l.03-.1.2-.64c-.24.07-.49.11-.74.11H6.4l-.16.01h-.52zm2.46-1h.85c.55 0 1.04-.34 1.26-.84l1.17-3.9c.07-.25.19-.49.34-.7h-.85c-.55 0-1.04.34-1.26.83l-1.17 3.91c-.08.25-.19.49-.34.7zm2.03-6.32c.24-.07.49-.11.74-.11h3.31c-.15-.22-.27-.45-.34-.7l-.47-1.6c-.17-.59-.71-.99-1.32-.99h-.02a.92.92 0 00-.76.38 4 4 0 00-.48.96c-.14.38-.28.82-.43 1.32l-.03.1-.2.64zm6.92 6.45c.42-1.35.88-2.82.86-3.95 0-.55-.13-.94-.35-1.2-.2-.23-.57-.42-1.28-.42h-2.62c-.61 0-1.15.4-1.32.99-.47 1.57-1.27 4.23-1.9 6.27l-.03.1c-.15.5-.3.96-.45 1.38-.13.35-.28.69-.46.98h4.48c.65 0 1.22-.4 1.76-1.19.53-.78.96-1.84 1.3-2.96z",
    fill: primaryFill
  }));
};
export const CopilotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotRegularIcon({}), 'CopilotRegular');
const CopilotBlueColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 3.35A1.88 1.88 0 0012.34 2h-.6c-.9 0-1.66.63-1.84 1.51L8.85 8.85l.3-.96c.24-.78.97-1.32 1.8-1.32h3.29l1.4 1.17 1.24-1.17h-.39c-.83 0-1.57-.55-1.8-1.35l-.55-1.87z",
    fill: "url(#paint0_radial_56279_101899)"
  }), React.createElement("path", {
    d: "M6.05 16.64c.23.8.97 1.36 1.8 1.36h1.22c1.01 0 1.84-.8 1.88-1.8l.18-5.06-.29.96c-.24.79-.97 1.33-1.8 1.33h-3.3l-1.39-.89-1.02.89h.38c.84 0 1.57.55 1.8 1.36l.54 1.85z",
    fill: "url(#paint1_radial_56279_101899)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint2_linear_56279_101899)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint3_linear_56279_101899)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint4_radial_56279_101899)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint5_linear_56279_101899)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_56279_101899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-129.14 9.97 .71) scale(7.20751 6.76953)"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0078D4"
  }), React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0C709B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0A5079"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_56279_101899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -13.8 12.43) scale(6.50473 6.39393)"
  }, React.createElement("stop", {
    stopColor: "#0091EB"
  }), React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2764E7"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0636C3"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_56279_101899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.73561 14.11098 -17.34225 -7.04901 17.09 5.45)"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#2771D8"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#14B1FF"
  }), React.createElement("stop", {
    offset: 0.93,
    stopColor: "#16BFDF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_56279_101899",
    x1: 4.41,
    y1: 2,
    x2: 6.4,
    y2: 14.09,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00A5D9"
  }), React.createElement("stop", {
    offset: 0.66,
    stopColor: "#21CAB2"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#6ADC90"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_56279_101899",
    x1: 6.11,
    y1: 2,
    x2: 6.59,
    y2: 13.44,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#10C9EC"
  }), React.createElement("stop", {
    offset: 0.17,
    stopColor: "#01AEE4",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint5_linear_56279_101899",
    x1: 17.56,
    y1: 6.13,
    x2: 16.84,
    y2: 10.55,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#14B1FF"
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2976DB",
    stopOpacity: 0
  }))));
};
export const CopilotBlueColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotBlueColorIcon({}), 'CopilotBlueColor');
const CopilotForSalesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 18h6.48a2.9 2.9 0 002.05-4.97L13 12.5 10.5 10H10l-6.26 2.74A2.9 2.9 0 002 15.4v.1A2.5 2.5 0 004.5 18z",
    fill: "url(#paint0_linear_60212_297)"
  }), React.createElement("path", {
    d: "M15.5 2H9.02c-2.4 0-3.7 2.7-2.4 4.56.2.28.36.6.38.94L9.5 10h.5l6.26-2.74A2.9 2.9 0 0018 4.6v-.1A2.5 2.5 0 0015.5 2z",
    fill: "url(#paint1_linear_60212_297)"
  }), React.createElement("path", {
    d: "M12.5 7h3.05C16.9 7 18 5.9 18 4.55v6.43a2.9 2.9 0 01-4.97 2.05L10 10v.5A2.5 2.5 0 017.5 13H4.45A2.45 2.45 0 002 15.45V9.02a2.9 2.9 0 014.97-2.05L10 10v-.5A2.5 2.5 0 0112.5 7z",
    fill: "url(#paint2_linear_60212_297)"
  }), React.createElement("g", {
    opacity: 0.25,
    fill: "#000"
  }, React.createElement("path", {
    d: "M7.5 14h-3a2.5 2.5 0 00-2.45 2 2.5 2.5 0 01-.05-.45v-.1A2.5 2.5 0 014.5 13h3a2.5 2.5 0 002.5-2.49v.99A2.5 2.5 0 017.5 14z"
  }), React.createElement("path", {
    d: "M10 10.49A2.5 2.5 0 0112.5 8h3a2.5 2.5 0 002.45-3 2.5 2.5 0 01-2.45 2h-3A2.5 2.5 0 0010 9.5v.99z"
  })), React.createElement("path", {
    opacity: 0.25,
    d: "M2.2 16.5c.3-.5.84-1.5 2.3-1.5h3a3.5 3.5 0 003.5-3.5v-1c0-.83.67-1.5 1.5-1.5h3c.98 0 1.86-.4 2.5-1.05V4.5A2.5 2.5 0 0115.5 7h-3A2.5 2.5 0 0010 9.5v1A2.5 2.5 0 017.5 13h-3a2.5 2.5 0 00-2.3 3.5z",
    fill: "#000",
    fillOpacity: 0.5
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_60212_297",
    x1: 1.73,
    y1: 17.82,
    x2: 10.69,
    y2: 8.73,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#122882"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1A43BC"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0BA0C5"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_60212_297",
    x1: 16.42,
    y1: 2,
    x2: 9.42,
    y2: 10.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9BF3AF"
  }), React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3DD9EB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCBFF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_60212_297",
    x1: 2,
    y1: 10.98,
    x2: 18.85,
    y2: 10.98,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2764E7"
  }), React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0099F8"
  }), React.createElement("stop", {
    offset: 0.73,
    stopColor: "#16BFDF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3EE5C9"
  }))));
};
export const CopilotForSalesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotForSalesColorIcon({}), 'CopilotForSalesColor');
const CopilotForSalesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10.25l2.9 2.9a2.4 2.4 0 004.1-1.7V6.25c-.53.47-1.23.76-2 .76h-3.5c-.83 0-1.5.67-1.5 1.5v1.75zm7-6.28v.06A2 2 0 0116 6h-3.5A2.5 2.5 0 0010 8.5v.75L6.85 6.1A2.4 2.4 0 018.55 2H16a2 2 0 012 1.97zM11.46 18H4a2 2 0 010-4h3.5a2.5 2.5 0 002.5-2.5v-.75l3.15 3.15a2.4 2.4 0 01-1.7 4.1zM2 8.54v5.22A2.99 2.99 0 014 13h3.5c.83 0 1.5-.67 1.5-1.5V9.75l-2.9-2.9A2.4 2.4 0 002 8.55z",
    fill: primaryFill
  }));
};
export const CopilotForSalesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotForSalesFilledIcon({}), 'CopilotForSalesFilled');
const CopilotForSalesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 15a3 3 0 003 3h5.86c2.23 0 3.6-2.07 3.18-3.96A3.26 3.26 0 0018 10.86V5a3 3 0 00-3-3H9.14a3.26 3.26 0 00-3.18 3.96A3.26 3.26 0 002 9.14V15zm4.84-7.46L9 9.71v.62C9 11.25 8.25 12 7.33 12H5c-.77 0-1.47.29-2 .76V9.14c0-2 2.42-3 3.84-1.6zM3 15C3 13.9 3.9 13 5 13h2.33c1.36 0 2.48-1 2.65-2.32l2.48 2.48a2.25 2.25 0 01-1.6 3.84H5a2 2 0 01-2-2zm10.16-2.53L11 10.29v-.62c0-.92.75-1.67 1.67-1.67H15c.77 0 1.47-.29 2-.76v3.62c0 2-2.42 3-3.84 1.6zM12.66 7c-1.35 0-2.47 1-2.64 2.32L7.54 6.84A2.25 2.25 0 019.14 3H15a2 2 0 110 4h-2.33z",
    fill: primaryFill
  }));
};
export const CopilotForSalesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotForSalesRegularIcon({}), 'CopilotForSalesRegular');
const CopilotGreenColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 3.35A1.88 1.88 0 0012.34 2h-.6c-.9 0-1.66.63-1.84 1.51L8.85 8.85l.3-.96c.24-.78.97-1.32 1.8-1.32h3.29l1.4 1.17 1.24-1.17h-.39c-.83 0-1.57-.55-1.8-1.35l-.55-1.87z",
    fill: "url(#paint0_radial_56279_101929)"
  }), React.createElement("path", {
    d: "M6.05 16.64c.23.8.97 1.36 1.8 1.36h1.22c1.01 0 1.84-.8 1.88-1.8l.18-5.06-.29.96c-.24.79-.97 1.33-1.8 1.33h-3.3l-1.39-.89-1.02.89h.38c.84 0 1.57.55 1.8 1.36l.54 1.85z",
    fill: "url(#paint1_radial_56279_101929)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint2_linear_56279_101929)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint3_linear_56279_101929)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint4_radial_56279_101929)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint5_linear_56279_101929)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_56279_101929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-3.54346 -5.55977 5.19545 -3.31127 14.84 7.27)"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4AA647"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1B7446"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0D5434"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_56279_101929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.76043 4.87213 -4.63547 2.62634 6.09 12.89)"
  }, React.createElement("stop", {
    stopColor: "#38B769"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#298756"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#13623D"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_56279_101929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.73561 14.11098 -17.34225 -7.04901 17.09 5.45)"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#338799"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#3CB173"
  }), React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9CCF6D"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_56279_101929",
    x1: 4.41,
    y1: 2,
    x2: 6.4,
    y2: 14.09,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4AA647"
  }), React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7DB22E"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A9D356"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_56279_101929",
    x1: 6.11,
    y1: 2,
    x2: 6.59,
    y2: 13.44,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#B5DA6B"
  }), React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5DAB3F",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint5_linear_56279_101929",
    x1: 17.29,
    y1: 6.57,
    x2: 16.66,
    y2: 12.28,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#35D0A9"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2BA46C",
    stopOpacity: 0
  }))));
};
export const CopilotGreenColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotGreenColorIcon({}), 'CopilotGreenColor');
const CopilotPurpleColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 3.35A1.88 1.88 0 0012.34 2h-.6c-.9 0-1.66.63-1.84 1.51L8.85 8.85l.3-.96c.24-.78.97-1.32 1.8-1.32h3.29l1.4 1.17 1.24-1.17h-.39c-.83 0-1.57-.55-1.8-1.35l-.55-1.87z",
    fill: "url(#paint0_radial_56279_101869)"
  }), React.createElement("path", {
    d: "M6.05 16.64c.23.8.97 1.36 1.8 1.36h1.22c1.01 0 1.84-.8 1.88-1.8l.18-5.06-.29.96c-.24.79-.97 1.33-1.8 1.33h-3.3l-1.39-.89-1.02.89h.38c.84 0 1.57.55 1.8 1.36l.54 1.85z",
    fill: "url(#paint1_radial_56279_101869)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint2_linear_56279_101869)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint3_linear_56279_101869)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint4_radial_56279_101869)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint5_linear_56279_101869)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_56279_101869",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.12365 -4.19904 4.13475 -4.06051 14.86 6.75)"
  }, React.createElement("stop", {
    stopColor: "#7D7DF2"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4A40D4"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2F27A5"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_56279_101869",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(51.73 -11.45 11.6) scale(6.58647 6.39483)"
  }, React.createElement("stop", {
    stopColor: "#A072EE"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#6C31D3"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#491D9F"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_56279_101869",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(116.34 6.77 8.3) scale(13.4892 16.5648)"
  }, React.createElement("stop", {
    stopColor: "#6462E4"
  }), React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6462E4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A071EE"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_56279_101869",
    x1: 5.59,
    y1: 15.88,
    x2: 6.5,
    y2: 0.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#00CCF9"
  }), React.createElement("stop", {
    offset: 0.42,
    stopColor: "#4A94FC"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#7D7DF2"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A071EE"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_56279_101869",
    x1: 6.11,
    y1: 2,
    x2: 6.59,
    y2: 13.44,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#B5BCFD"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9B9FF8",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint5_linear_56279_101869",
    x1: 16.06,
    y1: 6.02,
    x2: 15.36,
    y2: 9.86,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#B791F7"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A071EE",
    stopOpacity: 0
  }))));
};
export const CopilotPurpleColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotPurpleColorIcon({}), 'CopilotPurpleColor');
const CopilotRedColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 3.35A1.88 1.88 0 0012.34 2h-.6c-.9 0-1.66.63-1.84 1.51L8.85 8.85l.3-.96c.24-.78.97-1.32 1.8-1.32h3.29l1.4 1.17 1.24-1.17h-.39c-.83 0-1.57-.55-1.8-1.35l-.55-1.87z",
    fill: "url(#paint0_radial_56208_15910)"
  }), React.createElement("path", {
    d: "M6.05 16.64c.23.8.97 1.36 1.8 1.36h1.22c1.01 0 1.84-.8 1.88-1.8l.18-5.06-.29.96c-.24.79-.97 1.33-1.8 1.33h-3.3l-1.39-.89-1.02.89h.38c.84 0 1.57.55 1.8 1.36l.54 1.85z",
    fill: "url(#paint1_radial_56208_15910)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint2_linear_56208_15910)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint3_linear_56208_15910)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint4_radial_56208_15910)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint5_linear_56208_15910)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_56208_15910",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.69292 -6.89481 6.43245 -4.37822 15.71 8.9)"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E85EA2"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7347D"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#961F5A"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_56208_15910",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(51.73 -11.45 11.6) scale(6.58647 6.39483)"
  }, React.createElement("stop", {
    offset: 0.39,
    stopColor: "#DC384A"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A42331"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_56208_15910",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(114.7 7.53 7.48) scale(18.9535 23.2804)"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E03F8F"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB152"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_56208_15910",
    x1: 5.4,
    y1: -1.19,
    x2: 8.34,
    y2: 13.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EA348E"
  }), React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FD6544"
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FFB152"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_56208_15910",
    x1: 6.58,
    y1: 1.55,
    x2: 6.6,
    y2: 13.43,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F99ACD"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F44C6D",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint5_linear_56208_15910",
    x1: 17.6,
    y1: 5.87,
    x2: 17.24,
    y2: 9.66,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F8ADFA"
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#A86EDD",
    stopOpacity: 0
  }))));
};
export const CopilotRedColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotRedColorIcon({}), 'CopilotRedColor');
const DefenderColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 .5C6.3.5 6.72 3.05 1.89 3.05c-.54 0-.89.35-.89.78v3.63c-.01.85.05 1.7.18 2.54l.32.5 9.5.5-.5-10-.5-.5z",
    fill: "#36C2F1"
  }), React.createElement("path", {
    d: "M10 10l-1 5 1 4.5c.83 0 4.58-2.68 6.78-5.38A8.85 8.85 0 0018.82 10L14.5 9 10 10z",
    fill: "#105196"
  }), React.createElement("path", {
    d: "M18.82 10c.13-.84.2-1.7.18-2.54V3.83c0-.43-.35-.78-.89-.78C13.28 3.05 13.7.5 10 .5V10h8.82z",
    fill: "#0680D7"
  }), React.createElement("path", {
    d: "M1.18 10c.25 1.3.8 2.6 2.04 4.13 2.2 2.7 5.95 5.37 6.78 5.37V10H1.18z",
    fill: "#0373CC"
  }));
};
export const DefenderColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/DefenderColorIcon({}), 'DefenderColor');
const DefenderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.78 14.12c-1.9 2.33-4.94 4.64-6.28 5.23V9.5h8.39l-.07.5a8.85 8.85 0 01-2.04 4.12zm2.2-5.62H10.5V.52c1.4.1 2.14.6 2.94 1.12 1 .68 2.1 1.4 4.67 1.4.54 0 .89.36.89.8v3.62c0 .35 0 .7-.02 1.04zm-9.48 0V.52c-1.4.1-2.15.6-2.94 1.13a7.16 7.16 0 01-4.67 1.4c-.54 0-.89.35-.89.78v3.63c0 .35 0 .7.02 1.04H9.5zm-8.39 1l.07.5c.25 1.3.8 2.6 2.04 4.13 1.9 2.32 4.94 4.63 6.28 5.22V9.5H1.11z",
    fill: "#242424"
  }));
};
export const DefenderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DefenderFilledIcon({}), 'DefenderFilled');
const DefenderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18.82 10a8.85 8.85 0 01-2.04 4.12c-2.2 2.7-5.95 5.38-6.78 5.38h-.04c-.2-.02-.54-.16-.96-.4a24 24 0 01-5.78-4.97A8.88 8.88 0 011.18 10C1.05 9.16.98 8.3 1 7.46V3.83c0-.43.35-.78.89-.78 2.58 0 3.66-.73 4.67-1.4C7.44 1.05 8.27.5 10 .5c1.72 0 2.55.55 3.44 1.14 1 .68 2.1 1.4 4.67 1.4.54 0 .89.36.89.8v3.62c.01.85-.05 1.7-.18 2.54zM18 7.47V4.05a9.17 9.17 0 01-3.16-.51c-.83-.31-1.44-.72-1.94-1.05l-.02-.01c-.45-.3-.8-.53-1.22-.7-.3-.12-.67-.22-1.16-.26V8.5h7.48c.02-.34.02-.68.02-1.02v-.01zm-.12 2.03H10.5v8.73l.1-.06A23.2 23.2 0 0016 13.5a7.86 7.86 0 001.83-3.67V9.8l.05-.31zm-8.38-1V1.52c-.49.04-.86.14-1.17.26-.42.17-.76.4-1.21.7l-.02.01c-.5.34-1.11.74-1.94 1.05-.83.3-1.83.5-3.16.5v3.44c0 .34 0 .68.02 1.02H9.5zm-7.38 1l.04.3v.02A7.9 7.9 0 004 13.49a23.2 23.2 0 005.5 4.74V9.5H2.12z",
    fill: "#242424"
  }));
};
export const DefenderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DefenderRegularIcon({}), 'DefenderRegular');
const DesignerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.25 15a7.99 7.99 0 01-6.24 3H4a1 1 0 01-1-1v-1a6 6 0 016-6v-.25h6.25v5.24z",
    fill: "url(#paint0_radial_218573_1549)"
  }), React.createElement("path", {
    d: "M15.25 15a7.99 7.99 0 01-6.24 3H4a1 1 0 01-1-1v-1a6 6 0 016-6v-.25h6.25v5.24z",
    fill: "url(#paint1_radial_218573_1549)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M9 2H4a1 1 0 00-1 1v1a6 6 0 006 6h2.25a4 4 0 013.8 5.22A8 8 0 009 2z",
    fill: "url(#paint2_radial_218573_1549)"
  }), React.createElement("path", {
    d: "M9 2H4a1 1 0 00-1 1v1a6 6 0 006 6h2.25a4 4 0 013.8 5.22A8 8 0 009 2z",
    fill: "url(#paint3_radial_218573_1549)",
    fillOpacity: 0.5
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_218573_1549",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.12487 -8.2499 10.11492 12.41375 3 18.58)"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD7DFF"
  }), React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6864F6"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5750E2"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3E36B1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#261D82"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_218573_1549",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-160.3 9.73 7.43) scale(15.0593)"
  }, React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AC80FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BD96FF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_218573_1549",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.99976 11.01763 -9.10449 11.56878 3 2.48)"
  }, React.createElement("stop", {
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C354FF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_218573_1549",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.41642 -7.95828 7.55741 -10.84136 8.74 13.46)"
  }, React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFB357",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFB357"
  }))));
};
export const DesignerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignerColorIcon({}), 'DesignerColor');
const DesignerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 9.5h4a4.23 4.23 0 014.24 3.91A8 8 0 009.5 2H5a2 2 0 00-2 2 5.5 5.5 0 005.5 5.5zm6.56 6.25a3.25 3.25 0 00-2.56-5.25h-4A5.5 5.5 0 003 16c0 1.1.9 2 2 2h4.5c2.16 0 4.12-.86 5.56-2.25z",
    fill: primaryFill
  }));
};
export const DesignerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignerFilledIcon({}), 'DesignerFilled');
const DesignerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2 6.5 6.5 0 004 6 6.5 6.5 0 00-4 5.99V16c0 1.1.9 2 2 2h4.5a8 8 0 000-16H5zm11.5 8.01c0 1-.22 1.96-.6 2.83a4.25 4.25 0 00-4.15-3.34H9.5A5.5 5.5 0 014 4a1 1 0 011-1h4.5a7 7 0 017 7.01zm-1.57 4.4A6.99 6.99 0 019.5 17H5a1 1 0 01-1-1 5.5 5.5 0 015.5-5.5h2.25a3.25 3.25 0 013.18 3.92z",
    fill: primaryFill
  }));
};
export const DesignerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignerRegularIcon({}), 'DesignerRegular');
const DocumentOnePageLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h9c.83 0 1.5.67 1.5 1.5v5.7a5.5 5.5 0 00-3.8.3H7.42a.5.5 0 00.09 1h3.23A5.5 5.5 0 009.2 13H7.4a.5.5 0 00.09 1h1.52l-.02.5V18H5.5A1.5 1.5 0 014 16.5v-13zM12.5 7h.09a.5.5 0 00-.09-1H7.41a.5.5 0 00.09 1h5z",
    fill: primaryFill
  }));
};
export const DocumentOnePageLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageLoopFilledIcon({}), 'DocumentOnePageLoopFilled');
const DocumentOnePageLoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M14 2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h3v-1H6a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.2 9.5H7.42a.5.5 0 00.09 1h3.23c.43-.4.93-.75 1.48-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.2 13H7.42a.5.5 0 00.09 1h1.52c.03-.34.1-.68.19-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.59 7a.5.5 0 00-.09-1H7.41a.5.5 0 00.09 1h5.09z",
    fill: primaryFill
  }));
};
export const DocumentOnePageLoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageLoopRegularIcon({}), 'DocumentOnePageLoopRegular');
const EditorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.48 2.46a1 1 0 011.41-.28l2.7 1.9a1 1 0 01.24 1.38l-.47.7-4.3-3.06.42-.64zm-.96 1.48L13.8 7H17a1 1 0 110 2h-4.54l-.67 1H15a1 1 0 110 2h-4.55l-.67 1H13a1 1 0 110 2H8.44l-.52.78a.5.5 0 01-.2.17l-1.24.62-2.97-2.16.25-1.5a.5.5 0 01.07-.18l5.69-8.8zm-6.2 11.58l-.31 1.9a.5.5 0 00.71.53l1.75-.88-2.15-1.55z",
    fill: primaryFill
  }));
};
export const EditorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditorFilledIcon({}), 'EditorFilled');
const EditorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.9 2.18a1 1 0 00-1.42.28L3.83 12.73a.5.5 0 00-.07.19L3 17.42a.5.5 0 00.71.53l4-2a.5.5 0 00.2-.17l.52-.78H13a1 1 0 100-2H9.78l.67-1H15a1 1 0 100-2h-3.21l.67-1H17a1 1 0 100-2h-3.2l1.03-1.54a1 1 0 00-.25-1.37l-2.69-1.9zM10.33 4.5L13 6.4l-5.84 8.71-2.1 1.05-.74-.54.4-2.44 5.62-8.68z",
    fill: primaryFill
  }));
};
export const EditorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditorRegularIcon({}), 'EditorRegular');
const EventifyColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4a2 2 0 00-2-2H4a2 2 0 100 4h12a2 2 0 002-2z",
    fill: "url(#paint0_linear_164168_692)"
  }), React.createElement("path", {
    d: "M2 10c0-1.1.9-2 2-2h5a2 2 0 110 4H4a2 2 0 01-2-2z",
    fill: "url(#paint1_linear_164168_692)"
  }), React.createElement("path", {
    d: "M2 16c0-1.1.9-2 2-2h12a2 2 0 110 4H4a2 2 0 01-2-2z",
    fill: "url(#paint2_linear_164168_692)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_164168_692",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00FFD1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_164168_692",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00FFD1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_164168_692",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00FFD1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  }))));
};
export const EventifyColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/EventifyColorIcon({}), 'EventifyColor');
const EventifyMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4a2 2 0 00-2-2H4a2 2 0 100 4h12a2 2 0 002-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2 10c0-1.1.9-2 2-2h5a2 2 0 110 4H4a2 2 0 01-2-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2 16c0-1.1.9-2 2-2h12a2 2 0 110 4H4a2 2 0 01-2-2z",
    fill: primaryFill
  }));
};
export const EventifyMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/EventifyMonoIcon({}), 'EventifyMono');
const LineHorizontal4LoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M1.75 3.75c0-.41.34-.75.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17.5 7a.75.75 0 010 1.5h-15a.75.75 0 010-1.5h15z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2.5 11a.75.75 0 000 1.5h8.17c.34-.59.8-1.1 1.33-1.5H2.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10 15v1.5H2.5a.75.75 0 010-1.5H10z",
    fill: primaryFill
  }));
};
export const LineHorizontal4LoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal4LoopFilledIcon({}), 'LineHorizontal4LoopFilled');
const LoopColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8v8h8a8 8 0 100-16zm0 5.2a2.8 2.8 0 110 5.6H7.2V10A2.8 2.8 0 0110 7.2z",
    fill: "url(#paint0_linear_1_32)"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 01-8 8H2a5.2 5.2 0 015.2-5.2H10a2.8 2.8 0 002.8-2.8H18z",
    fill: "url(#paint1_linear_1_32)"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 01-8 8H2a5.2 5.2 0 015.2-5.2H10a2.8 2.8 0 002.8-2.8H18z",
    fill: "url(#paint2_radial_1_32)",
    fillOpacity: 0.56
  }), React.createElement("path", {
    d: "M18 10a8 8 0 01-8 8H2a5.2 5.2 0 015.2-5.2H10a2.8 2.8 0 002.8-2.8H18z",
    fill: "url(#paint3_radial_1_32)",
    fillOpacity: 0.1
  }), React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8v8a5.2 5.2 0 005.2-5.18l.02-.02H7.2V10A2.8 2.8 0 0112 8.04l3.68-3.68A7.98 7.98 0 0010 2z",
    fill: "url(#paint4_linear_1_32)"
  }), React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8v8a5.2 5.2 0 005.2-5.18l.02-.02H7.2V10A2.8 2.8 0 0112 8.04l3.68-3.68A7.98 7.98 0 0010 2z",
    fill: "url(#paint5_radial_1_32)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_1_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.2 2.2 -3.86655 5.62407 4.8 14.6)"
  }, React.createElement("stop", null), React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint3_radial_1_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.92 3.68 -6.46767 10.4045 3.84 14)"
  }, React.createElement("stop", {
    offset: 0.33
  }), React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_1_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.72004 -1.84 4.83761 28.18435 .64 6.96)"
  }, React.createElement("stop", {
    stopColor: "#6D05E8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6D05E8",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_1_32",
    x1: 11.76,
    y1: 7.68,
    x2: 9.12,
    y2: 18.48,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9237E3"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#48E6F3"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_1_32",
    x1: 7.2,
    y1: 16.8,
    x2: 14.24,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#51E6FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#71D4FF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_1_32",
    x1: 5.28,
    y1: 10.56,
    x2: 9.36,
    y2: 4.8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6D05E8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AB5ADD",
    stopOpacity: 0
  }))));
};
export const LoopColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/LoopColorIcon({}), 'LoopColor');
const LoopMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 18v-8a8 8 0 118 8H2zm3.45-1H10a7 7 0 10-7-7v6.96a4.74 4.74 0 002.58-1.38c.87-.86 1.42-2 1.42-3.08V10a3 3 0 113 3H7.97a5.7 5.7 0 01-1.68 3.3c-.26.25-.54.49-.84.7zM8 12h2a2 2 0 10-2-2v2z",
    fill: primaryFill
  }));
};
export const LoopMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/LoopMonoIcon({}), 'LoopMono');
const M365ColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.2 1.92L3.5 4.63A3 3 0 002 7.23v5.54a3 3 0 001.5 2.6l2.27 1.3.22-.67 4.25-2.54-1.74-1A3 3 0 017 9.85V8.27l.47-.59L9 6.49V3l-.68-.99-.73.53a3 3 0 01.6-.62z",
    fill: "url(#paint0_linear_1_160)"
  }), React.createElement("path", {
    d: "M8.2 1.92L3.5 4.63A3 3 0 002 7.23v5.54a3 3 0 001.5 2.6l2.27 1.3.22-.67 4.25-2.54-1.74-1A3 3 0 017 9.85V8.27l.47-.59L9 6.49V3l-.68-.99-.73.53a3 3 0 01.6-.62z",
    fill: "url(#paint1_linear_1_160)"
  }), React.createElement("path", {
    d: "M13 7.62v2.24a3 3 0 01-1.5 2.6l-5 2.88a3 3 0 01-3 0l-.3-.17.3.2 5 2.88a3 3 0 003 0l5-2.88a3 3 0 001.5-2.6v-2.08l-5-3.07z",
    fill: "url(#paint2_radial_1_160)"
  }), React.createElement("path", {
    d: "M13 7.62v2.24a3 3 0 01-1.5 2.6l-5 2.88a3 3 0 01-3 0l-.3-.17.3.2 5 2.88a3 3 0 003 0l5-2.88a3 3 0 001.5-2.6v-2.08l-5-3.07z",
    fill: "url(#paint3_linear_1_160)"
  }), React.createElement("path", {
    d: "M8.2 1.92l.3-.17a3 3 0 013 0l5 2.88a3 3 0 011.5 2.6v5.6a3 3 0 00-1.5-2.54l-5-2.88a3 3 0 00-3 0L7 8.27V4.32a3 3 0 011.2-2.4z",
    fill: "url(#paint4_radial_1_160)"
  }), React.createElement("path", {
    d: "M8.2 1.92l.3-.17a3 3 0 013 0l5 2.88a3 3 0 011.5 2.6v5.6a3 3 0 00-1.5-2.54l-5-2.88a3 3 0 00-3 0L7 8.27V4.32a3 3 0 011.2-2.4z",
    fill: "url(#paint5_linear_1_160)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_1_160",
    x1: 9.09,
    y1: 5.83,
    x2: 4.74,
    y2: 18.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#AE7FE2"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_1_160",
    x1: 7.44,
    y1: 15.22,
    x2: 6.69,
    y2: 13.89,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint3_linear_1_160",
    x1: 15.83,
    y1: 9.85,
    x2: 15.11,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 1,
    stopColor: "#493474"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8C66BA",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint5_linear_1_160",
    x1: 7.02,
    y1: 5.56,
    x2: 8.18,
    y2: 5.56,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_1_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.44626 -2.8892 2.22564 9.58779 5.15 14.76)"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D59DFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5E438F"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_1_160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-143.08 10 2.4) scale(11.412)"
  }, React.createElement("stop", {
    stopColor: "#50E6FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD"
  }))));
};
export const M365Color = /*#__PURE__*/wrapIcon( /*#__PURE__*/M365ColorIcon({}), 'M365Color');
const M365FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.46 4.34L7.03 2.2a2.5 2.5 0 00-.03.36v7.8c0 .89.46 1.7 1.21 2.15l.89.53-4.11 2.58c-.47.3-1.06.3-1.53.04a3 3 0 01-.24-.17l-.32-.27a3 3 0 01-.9-2.14V6.92a3 3 0 011.46-2.58zm1.67 12.32L8.2 18.5c1.1.67 2.5.67 3.6 0l4.74-2.84A3 3 0 0018 13.08v-.1a1 1 0 00-.48-.72L13 9.54v.85a2.5 2.5 0 01-1.17 2.12l-6.31 3.96a2.5 2.5 0 01-.39.2zM18 6.92v4.46l-6.71-4.03a2.5 2.5 0 00-2.58 0L8 7.77V2.56c0-.64.4-1.21 1.01-1.42h.02a3.5 3.5 0 012.77.36l4.74 2.84A3 3 0 0118 6.92z",
    fill: primaryFill
  }));
};
export const M365Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/M365FilledIcon({}), 'M365Filled');
const M365RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 13.08a3 3 0 01-1.46 2.58L11.8 18.5a3.5 3.5 0 01-3.6 0L3.9 15.93a2.51 2.51 0 01-.11-.07l-.34-.2A3 3 0 012 13.08V6.92a3 3 0 011.46-2.58L8.1 1.55l.35-.2.31-.13.03-.01a3.5 3.5 0 013 .29l4.74 2.84A3 3 0 0118 6.92v6.16zM9.14 2.15l-.23.1-.02.01a2.5 2.5 0 00-.18.1l-.06.03c-.4.28-.65.74-.65 1.24v4.14l.71-.42a2.5 2.5 0 012.58 0l5.5 3.3.21.14V6.92a2 2 0 00-.97-1.72l-4.74-2.85a2.5 2.5 0 00-2.15-.2zM8 8.95v1.42c0 .52.28 1.01.73 1.28l1.32.8 1.25-.79c.43-.27.7-.75.7-1.27V8.94l-1.23-.74a1.5 1.5 0 00-1.54 0L8 8.94zm5 .59v.85a2.5 2.5 0 01-1.17 2.12l-5.36 3.36c-.12.08-.25.14-.38.2l2.62 1.58c.8.47 1.78.47 2.58 0l4.74-2.85a2 2 0 00.97-1.72v-.29a1.5 1.5 0 00-.73-1.29L13 9.54zm-9.27 5.1l.6.37.08.05a1.5 1.5 0 001.53-.04l3.16-1.98-.89-.53A2.5 2.5 0 017 10.37V3.63l.01-.25L3.97 5.2A2 2 0 003 6.92v6.16a2 2 0 00.73 1.55z",
    fill: primaryFill
  }));
};
export const M365Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/M365RegularIcon({}), 'M365Regular');
const NewsletterColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 15.5a1.5 1.5 0 003 0V5a1 1 0 00-1-1h-2v11.5z",
    fill: "url(#paint0_linear_63490_22024)"
  }), React.createElement("path", {
    d: "M14 15.5a1.5 1.5 0 003 0V5a1 1 0 00-1-1h-2v11.5z",
    fill: "url(#paint1_linear_63490_22024)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M14 15.5a1.5 1.5 0 003 0V5a1 1 0 00-1-1h-2v11.5z",
    fill: "url(#paint2_linear_63490_22024)",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M4.5 17A1.5 1.5 0 013 15.5V4a1 1 0 011-1h9a1 1 0 011 1v11.5c0 .83.67 1.5 1.5 1.5h-11z",
    fill: "url(#paint3_linear_63490_22024)"
  }), React.createElement("path", {
    d: "M6.5 17A1.5 1.5 0 015 15.5v-3c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v3c0 .83.67 1.5 1.5 1.5h-7z",
    fill: "url(#paint4_linear_63490_22024)"
  }), React.createElement("rect", {
    width: 7,
    height: 2,
    rx: 0.5,
    transform: "matrix(1 0 0 -1 5 11)",
    fill: "#0084DF"
  }), React.createElement("rect", {
    x: 5,
    y: 5,
    width: 7,
    height: 3,
    rx: 0.5,
    fill: "url(#paint5_linear_63490_22024)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_63490_22024",
    x1: 15.5,
    y1: 17,
    x2: 15.5,
    y2: 7.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00479E"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_63490_22024",
    x1: 13,
    y1: 10,
    x2: 15,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.44
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint2_linear_63490_22024",
    x1: 13,
    y1: 10,
    x2: 15,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.48
  }), React.createElement("stop", {
    offset: 0.71,
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint3_linear_63490_22024",
    x1: 7.75,
    y1: 18,
    x2: 7.75,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0078D4"
  }), React.createElement("stop", {
    offset: 0.14,
    stopColor: "#14B1FF"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3DCBFF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_63490_22024",
    x1: 6.75,
    y1: 17,
    x2: 6.75,
    y2: 8.11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0057AD"
  }), React.createElement("stop", {
    offset: 0.14,
    stopColor: "#0078D4"
  }), React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0091EB"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_63490_22024",
    x1: 8.5,
    y1: 5,
    x2: 8.5,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D7F7FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#ABEEFF"
  }))));
};
export const NewsletterColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewsletterColorIcon({}), 'NewsletterColor');
const NewsletterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.99 4.77H14v9.73a.5.5 0 001 0V4a2 2 0 012 2v8.5a2.5 2.5 0 01-5 0V13a1 1 0 00-1-1H6a1 1 0 00-1 1v2.5c0 .54.17 1.04.46 1.45A3 3 0 013 14V5c0-1.1.9-2 2-2h7a2 2 0 011.99 1.77zM7.5 17h4.55A3.49 3.49 0 0111 14.5V13H6v2.5c0 .83.67 1.5 1.5 1.5zM6 5a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V6a1 1 0 00-1-1H6zm0 1h5v2H6V6zm-1 4.5c0 .28.22.5.5.5h6a.5.5 0 000-1h-6a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};
export const NewsletterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewsletterFilledIcon({}), 'NewsletterFilled');
const NewsletterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v9a3 3 0 003 3h8.5a2.5 2.5 0 002.5-2.5V6a2 2 0 00-2-2h-.27A2 2 0 0013 3H5zm9.5 13a1.5 1.5 0 01-1.5-1.5V13a1 1 0 00-1-1H6a1 1 0 00-1 1v2c0 .3.06.57.18.82A2 2 0 014 14V5a1 1 0 011-1h8a1 1 0 011 1v9.5a.5.5 0 001 0V5a1 1 0 011 1v8.5c0 .83-.67 1.5-1.5 1.5zM7 16a1 1 0 01-1-1v-2h6v1.5c0 .56.19 1.08.5 1.5H7zM6 5a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V6a1 1 0 00-1-1H6zm0 1h6v2H6V6zm-1 4.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};
export const NewsletterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewsletterRegularIcon({}), 'NewsletterRegular');
const NotepadLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.47a3.37 3.37 0 001.35-2.7h1.12a1.8 1.8 0 10-1.8-1.8v1.8A2.7 2.7 0 0110 19v-4.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M6.5 2c.28 0 .5.22.5.5V3h2.5v-.5a.5.5 0 011 0V3H13v-.5a.5.5 0 011 0V3h.5c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 00-4.66.8H7.5a.5.5 0 000 1h2.76a5.48 5.48 0 00-1.05 2H7.5a.5.5 0 000 1h1.52l-.02.5V18H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3H6v-.5c0-.28.22-.5.5-.5zm1 5a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};
export const NotepadLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadLoopFilledIcon({}), 'NotepadLoopFilled');
const NotepadLoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.47a3.37 3.37 0 001.35-2.7h1.12a1.8 1.8 0 10-1.8-1.8v1.8A2.7 2.7 0 0110 19v-4.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M7 7.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.5 10a.5.5 0 000 1h2.76c.31-.38.67-.72 1.08-1H7.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M15 9.02V4.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v12c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3H6v-.5a.5.5 0 011 0V3h2.5v-.5a.5.5 0 011 0V3H13v-.5a.5.5 0 011 0V3h.5c.83 0 1.5.67 1.5 1.5v4.7c-.32-.08-.66-.15-1-.18z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.2 13c-.08.32-.15.66-.18 1H7.5a.5.5 0 010-1h1.7z",
    fill: primaryFill
  }));
};
export const NotepadLoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadLoopRegularIcon({}), 'NotepadLoopRegular');
const OfficeColorFallbackIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 15.92V4.08a1.85 1.85 0 00-1.34-1.78L10.72.57 12 4v11l-1.29 4.43 6-1.72A1.87 1.87 0 0018 15.92z",
    fill: "#F32B44"
  }), React.createElement("path", {
    d: "M12 15H6.45a1.23 1.23 0 00-.61 2.3l3.5 2c.27.15.57.23.88.23A1.78 1.78 0 0012 17.75V15z",
    fill: "#C72127"
  }), React.createElement("path", {
    d: "M10.72.57a1.72 1.72 0 00-1.38.17L2.93 4.46A1.86 1.86 0 002 6.07v8a.9.9 0 001.34.78l2-1.1a1.37 1.37 0 00.7-1.19v-5.5a1.38 1.38 0 01.91-1.29L12 4V2.27a1.77 1.77 0 00-1.28-1.7z",
    fill: "#C72127"
  }));
};
export const OfficeColorFallback = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeColorFallbackIcon({}), 'OfficeColorFallback');
const OfficeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 15.92V4.08a1.85 1.85 0 00-1.34-1.78L10.72.57 12 4v11l-1.29 4.43 6-1.72A1.87 1.87 0 0018 15.92z",
    fill: "url(#paint0_linear_38966_55081)"
  }), React.createElement("path", {
    d: "M12 15H6.45a1.23 1.23 0 00-.61 2.3l3.5 2c.27.15.57.23.88.23A1.78 1.78 0 0012 17.75V15z",
    fill: "url(#paint1_linear_38966_55081)"
  }), React.createElement("path", {
    d: "M10.72.57a1.72 1.72 0 00-1.38.17L2.93 4.46A1.86 1.86 0 002 6.07v8a.9.9 0 001.34.78l2-1.1a1.37 1.37 0 00.7-1.19v-5.5a1.38 1.38 0 01.91-1.29L12 4V2.27a1.77 1.77 0 00-1.28-1.7z",
    fill: "url(#paint2_linear_38966_55081)"
  }), React.createElement("path", {
    d: "M12 15H6.45a1.23 1.23 0 00-.61 2.3l3.5 2c.27.15.57.23.88.23A1.78 1.78 0 0012 17.75V15z",
    fill: "url(#paint3_linear_38966_55081)"
  }), React.createElement("path", {
    d: "M10.72.57a1.72 1.72 0 00-1.38.17L2.93 4.46A1.86 1.86 0 002 6.07v8a.9.9 0 001.34.78l2-1.1a1.37 1.37 0 00.7-1.19v-5.5a1.38 1.38 0 01.91-1.29L12 4V2.27a1.77 1.77 0 00-1.28-1.7z",
    fill: "url(#paint4_linear_38966_55081)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_38966_55081",
    x1: 14.23,
    y1: -0.54,
    x2: 14.42,
    y2: 18.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFCE00"
  }), React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FABB00"
  }), React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EB8401"
  }), React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E15C01"
  }), React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DA4401"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D83B01"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_38966_55081",
    x1: 5.76,
    y1: 17.25,
    x2: 18.22,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FA2C46"
  }), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B0080B"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_38966_55081",
    x1: 10.49,
    y1: -0.01,
    x2: 0.64,
    y2: 14.05,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8C0700"
  }), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C72127"
  }), React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CA2B3D"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D04374"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D5559C"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D860B4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D964BD"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_38966_55081",
    x1: 14.27,
    y1: 17.53,
    x2: 8.66,
    y2: 17.04,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopOpacity: 0.4
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_38966_55081",
    x1: 10.69,
    y1: -0.3,
    x2: 8.6,
    y2: 2.68,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopOpacity: 0.4
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))));
};
export const OfficeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeColorIcon({}), 'OfficeColor');
const OfficeMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.66 2.3L10.72.57a1.72 1.72 0 00-1.38.17L2.93 4.46A1.85 1.85 0 002 6.07v8a.9.9 0 001.34.78l2-1.1a1.37 1.37 0 00.7-1.19v-5.5a1.38 1.38 0 01.91-1.29l4.09-1.45V15H6.49a1.23 1.23 0 00-.61 2.3l3.5 2a1.81 1.81 0 001.37.16l6-1.72a1.87 1.87 0 001.34-1.79V4.08a1.85 1.85 0 00-1.43-1.78zM17 15.92a.88.88 0 01-.62.83L12 18V2.27v-.29l4.4 1.28a.85.85 0 01.62.82L17 15.92z",
    fill: primaryFill
  }));
};
export const OfficeMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeMonoIcon({}), 'OfficeMono');
const OfficeExcelColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a1 1 0 011-1h11a1 1 0 011 1v8H5V3z",
    fill: "#21A366"
  }), React.createElement("path", {
    d: "M18 10H5v4l7 1.4 6-1.4v-4z",
    fill: "#107C41"
  }), React.createElement("path", {
    d: "M5 14v3c0 .6.5 1 1 1h11c.6 0 1-.4 1-1v-3H5z",
    fill: "#185C37"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M12 6H5v10h6a2 2 0 002-2V7c0-.6-.4-1-1-1z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 15H3c-.6 0-1-.4-1-1V6c0-.5.4-1 1-1h8c.6 0 1 .5 1 1v8c0 .6-.4 1-1 1z",
    fill: "#107C41"
  }), React.createElement("path", {
    d: "M4.3 13l1.9-3-1.7-3h1.4l1 1.9c0 .2.1.3.1.4.1-.1.2-.3.3-.4l1-1.9h1.3l-1.8 3 1.9 3H8.3l-1.2-2.1c0-.1-.1-.2-.1-.3 0 .1-.1.2-.1.3L5.7 13H4.3z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M18 3v3h-6V2h5c.5 0 1 .5 1 1z",
    fill: "#33C481"
  }));
};
export const OfficeExcelColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeExcelColorIcon({}), 'OfficeExcelColor');
const OfficeExcelMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 15v2c0 .5.4 1 1 1h11c.6 0 1-.5 1-1V3c0-.5-.4-1-1-1H6a1 1 0 00-1 1v2H3a1 1 0 00-1 1v8c0 .5.4 1 1 1h2zm7-4h5v3h-5v-3zm0-1V7h5v3h-5zm-6 5h5v2H6v-2zm6 2v-2h5v2h-5zm5-11h-5V3h5v3zM6 3h5v2H6V3zm2.1 10.2l-1.1-2-1.1 2.1h-2l2-3.3L4 6.8h2l1 2 1.1-2H10L8.1 10l2 3.3h-2v-.1z",
    fill: primaryFill
  }));
};
export const OfficeExcelMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeExcelMonoIcon({}), 'OfficeExcelMono');
const OfficeFormsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M20 10l-7-2-8 2v8.2c0 .5.4.8.8.8h13.4c.5 0 .8-.4.8-.8V10z",
    fill: "#036C70"
  }), React.createElement("path", {
    d: "M19.2 1H5.8c-.4 0-.8.4-.8.8V10h15V1.8c0-.4-.4-.8-.8-.8z",
    fill: "#37C6D0"
  }), React.createElement("path", {
    d: "M18 12h-5v5h5v-5z",
    fill: "#1A9BA1"
  }), React.createElement("path", {
    d: "M15.5 9a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    fill: "#1A9BA1"
  }), React.createElement("path", {
    d: "M15.5 7.5a2 2 0 100-4 2 2 0 000 4z",
    fill: "#036C70"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M12 5H5v12h6.8c.6 0 1.2-.6 1.2-1.2V6c0-.5-.5-1-1-1z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 16H1a1 1 0 01-1-1V5c0-.6.5-1 1-1h10c.5 0 1 .4 1 1v10c0 .6-.5 1-1 1z",
    fill: "#038387"
  }), React.createElement("path", {
    d: "M7.7 7.6H4.6v2h2.9v1.2H4.6v2.9H3.2V6.4h4.5v1.2z",
    fill: "#fff"
  }));
};
export const OfficeFormsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeFormsColorIcon({}), 'OfficeFormsColor');
const OfficeOneDriveColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93 9.56h11.28v-1.8A6.22 6.22 0 004.93 5.86v3.71z",
    fill: "#0364B8"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63 6.61A4.92 4.92 0 005 5.85h-.06A5.1 5.1 0 00.9 13.83h10.93V9.17l-4.2-2.55z",
    fill: "#0078D4"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.21 7.77a4.07 4.07 0 00-1.88.32l-2.5 1.07v4.67h7.68a4.15 4.15 0 00-3.3-6.06z",
    fill: "#1490DF"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.97 11.68l-1.04-.63-2.38-1.45-.72-.44-1.92.82-3.66 1.56-1.65.7-3.7 1.59A4.97 4.97 0 005 16h10.94c1.54 0 2.89-.88 3.57-2.17l-3.54-2.15z",
    fill: "#28A8EA"
  }));
};
export const OfficeOneDriveColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeOneDriveColorIcon({}), 'OfficeOneDriveColor');
const OfficeOneDriveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.21 7.77A6.22 6.22 0 004.93 5.86 5.1 5.1 0 00.9 13.83 4.97 4.97 0 005 16h10.94a4.03 4.03 0 003.57-2.17 4.15 4.15 0 00-3.3-6.06z",
    fill: primaryFill
  }));
};
export const OfficeOneDriveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeOneDriveFilledIcon({}), 'OfficeOneDriveFilled');
const OfficeOneDriveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19.51 13.83a4.15 4.15 0 00-3.3-6.06A6.22 6.22 0 004.93 5.86 5.1 5.1 0 00.9 13.83 4.97 4.97 0 005 16h10.94a4.03 4.03 0 003.57-2.17zM15.23 8a1 1 0 00.91.77A3.1 3.1 0 0119 11.88a3.15 3.15 0 01-.39 1.52 3.05 3.05 0 01-2.67 1.6H5a3.97 3.97 0 01-3.29-1.75 4.1 4.1 0 013.24-6.4 1 1 0 00.83-.47A5.22 5.22 0 0115.23 8z",
    fill: primaryFill
  }));
};
export const OfficeOneDriveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeOneDriveRegularIcon({}), 'OfficeOneDriveRegular');
const OfficeOnenoteColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 2H5a1 1 0 00-1 1v14a1 1 0 001 1h10.53A1.47 1.47 0 0017 16.53V3a1 1 0 00-1-1z",
    fill: "#CA64EA"
  }), React.createElement("path", {
    d: "M17 6h-4v4h4V6z",
    fill: "#AE4BD5"
  }), React.createElement("path", {
    opacity: 0.75,
    d: "M11 6H4v10h6.22A1.78 1.78 0 0012 14.22V7a1 1 0 00-1-1z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M10 5H2a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: "#7719AA"
  }), React.createElement("path", {
    d: "M3.15 7h1.31l3.12 4 .26.43a5.07 5.07 0 010-.82V7h1.1v6H7.71L4.5 8.91a3.44 3.44 0 01-.24-.42c.02.3.02.6 0 .89V13H3.15V7z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M17 10h-4v4h4v-4z",
    fill: "#9332BF"
  }), React.createElement("path", {
    d: "M13 14v4h3a1 1 0 001-1v-3h-4z",
    fill: "#7719AA"
  }));
};
export const OfficeOnenoteColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeOnenoteColorIcon({}), 'OfficeOnenoteColor');
const OfficeOnenoteMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 15v2a1 1 0 001 1h11a1 1 0 001-1V3a1 1 0 00-1-1H6a1 1 0 00-1 1v2H3a1 1 0 00-1 1v8a1 1 0 001 1h2zm12 2h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3V6h3v3zM6 3h11v2h-4v12H6v-2h5a1 1 0 001-1V6a1 1 0 00-1-1H6V3zm2.59 10.25l-3.06-3.9v3.9H3.91v-6.5h1.68l3 3.81V6.75h1.62v6.5H8.59z",
    fill: primaryFill
  }));
};
export const OfficeOnenoteMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeOnenoteMonoIcon({}), 'OfficeOnenoteMono');
const OfficeOutlookColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.8 9.52l-6.3-3.6h-.09a.79.79 0 00-.37-.14.86.86 0 00-.39.09h-.09l-6.3 3.6a.38.38 0 00-.19.34.39.39 0 00.18.33L11.04 15l6.81-4.81a.4.4 0 00.19-.33.39.39 0 00-.24-.34z",
    fill: "#0A2767"
  }), React.createElement("path", {
    d: "M16.04 2h-10a1 1 0 00-1 1l6 2 6-2a1 1 0 00-1-1z",
    fill: "#0364B8"
  }), React.createElement("path", {
    d: "M11 3H5v6l5.99 6.01h6V8.99L11 3z",
    fill: "#28A8EA"
  }), React.createElement("path", {
    d: "M17 3h-6v6h6V3z",
    fill: "#50D9FF"
  }), React.createElement("path", {
    d: "M10.99 15.01L5 15V9h6l-.01 6.01z",
    fill: "#0078D4"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M11.04 15l-6.83-4.83.51-.88 6.32 3.58 6.28-3.59.49.91L11.04 15z",
    fill: "#0A2767"
  }), React.createElement("path", {
    d: "M17.81 10.19l-6.31 3.59a.89.89 0 01-.47.14h-.06a1 1 0 01-.25 0L13.04 17l4.64.83a.88.88 0 00.36-.71V9.86a.4.4 0 01-.23.33z",
    fill: "#1490DF"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M12.04 13.48l-.54.31a.9.9 0 01-.47.14h-.06a1 1 0 01-.25 0L13.04 17l4.64.83a.88.88 0 00.36-.71v-.27l-6-3.37z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M4.18 10.19a.39.39 0 01-.14-.33v7.27a.87.87 0 00.58.82c.1.02.2.02.29 0h12.21c.18 0 .36-.05.51-.16l-13.45-7.6z",
    fill: "#28A8EA"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M11.04 16a2 2 0 002-2V7a1 1 0 00-1-1h-7v3.07l-.79.45a.4.4 0 00-.19.33h-.02v6.14l7 .01z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 5H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: "#0078D4"
  }), React.createElement("path", {
    d: "M4.2 8.37c.24-.5.63-.9 1.11-1.17a3.51 3.51 0 011.73-.42c.57-.01 1.14.12 1.64.4.48.25.87.64 1.13 1.11.26.5.39 1.07.38 1.64.01.6-.12 1.19-.39 1.72-.26.48-.65.87-1.12 1.13-.52.28-1.1.42-1.7.41a3.37 3.37 0 01-1.68-.41 2.82 2.82 0 01-1.1-1.12 3.7 3.7 0 010-3.29zm1.19 2.73c.13.31.34.58.62.77.3.2.65.3 1 .28.35 0 .7-.1 1-.29.28-.19.49-.46.61-.77a3.14 3.14 0 00.01-2.15 1.62 1.62 0 00-1.59-1.1c-.35-.01-.7.09-1 .28-.28.2-.5.46-.64.77-.15.35-.23.73-.22 1.11-.01.38.06.75.21 1.1z",
    fill: "#fff"
  }));
};
export const OfficeOutlookColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeOutlookColorIcon({}), 'OfficeOutlookColor');
const OfficeOutlookMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 9.85a.38.38 0 00-.19-.33L17 9.06V3a1 1 0 00-1-1H6a1 1 0 00-1 1v2H3a1 1 0 00-1 1v8a1 1 0 001 1h1v2.11a.89.89 0 00.89.89h12.22a.9.9 0 00.89-.89V9.85zM11 4h5v4h-4V6a1 1 0 00-1-1V4zm5 5v1l-4 2.3V9h4zM6 4h4v1H6V4zm-2 7.8a4 4 0 01-.02-3.56c.27-.53.7-.97 1.22-1.26a3.75 3.75 0 011.89-.45c.61-.01 1.22.13 1.76.43a3 3 0 011.19 1.21c.28.54.42 1.15.41 1.76a4 4 0 01-.42 1.83c-.27.54-.7 1-1.22 1.3-.56.3-1.18.46-1.82.45a3.58 3.58 0 01-1.8-.45 3 3 0 01-1.2-1.26H4zM5 17v-2h6a1 1 0 00.8-.44L16.17 17H5zm12-.68l-5-2.79v-.07l5-2.84v5.71-.01zM6.16 11.66c.25.17.54.25.84.24.32.02.63-.07.9-.25.24-.16.42-.39.52-.65.13-.32.19-.66.18-1 0-.32-.06-.64-.17-.94-.1-.27-.27-.5-.5-.68a1.5 1.5 0 00-1.75-.08c-.25.16-.44.4-.55.67-.14.31-.2.66-.2 1 0 .34.06.68.19 1 .1.28.3.52.54.69z",
    fill: primaryFill
  }));
};
export const OfficeOutlookMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeOutlookMonoIcon({}), 'OfficeOutlookMono');
const OfficePlannerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.2 12.8c-.78.78-2.04.78-2.81 0L1.59 10a1.98 1.98 0 010-2.8l2.8-2.81a1.98 1.98 0 012.8 0L10 7.19c.77.78.77 2.04 0 2.81l-2.8 2.8z",
    fill: "url(#paint0_linear_61942_8511)"
  }), React.createElement("path", {
    d: "M7.2 12.8c-.78.78-2.04.78-2.81 0L1.59 10a1.98 1.98 0 010-2.8l2.8-2.81a1.98 1.98 0 012.8 0L10 7.19c.77.78.77 2.04 0 2.81l-2.8 2.8z",
    fill: "url(#paint1_linear_61942_8511)"
  }), React.createElement("path", {
    d: "M1.58 10c.78.78 2.03.78 2.8 0l8.43-8.42a1.98 1.98 0 012.8 0l2.8 2.8c.78.78.78 2.04 0 2.81L10 15.61c-.77.78-2.03.78-2.8 0L1.57 10z",
    fill: "url(#paint2_linear_61942_8511)"
  }), React.createElement("path", {
    d: "M1.58 10c.78.78 2.03.78 2.8 0l8.43-8.42a1.98 1.98 0 012.8 0l2.8 2.8c.78.78.78 2.04 0 2.81L10 15.61c-.77.78-2.03.78-2.8 0L1.57 10z",
    fill: "url(#paint3_linear_61942_8511)"
  }), React.createElement("path", {
    d: "M4.39 12.8c.77.78 2.03.78 2.8 0l5.62-5.6a1.98 1.98 0 012.8 0l2.8 2.8c.78.77.78 2.03 0 2.8l-5.6 5.62c-.78.77-2.03.77-2.81 0L4.39 12.8z",
    fill: "url(#paint4_linear_61942_8511)"
  }), React.createElement("path", {
    d: "M4.39 12.8c.77.78 2.03.78 2.8 0l5.62-5.6a1.98 1.98 0 012.8 0l2.8 2.8c.78.77.78 2.03 0 2.8l-5.6 5.62c-.78.77-2.03.77-2.81 0L4.39 12.8z",
    fill: "url(#paint5_linear_61942_8511)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_61942_8511",
    x1: 5.79,
    y1: 3.81,
    x2: 2.62,
    y2: 10.58,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8752E0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#541278"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_61942_8511",
    x1: 7.29,
    y1: 9.3,
    x2: 4.71,
    y2: 6.77,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3D0D59"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7034B0",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint2_linear_61942_8511",
    x1: 14.78,
    y1: 1,
    x2: 8.39,
    y2: 16.31,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#DB45E0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6C0F71"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_61942_8511",
    x1: 14.78,
    y1: 1,
    x2: 8.39,
    y2: 16.31,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#DB45E0"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A829AE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8F28B3"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_61942_8511",
    x1: 14.5,
    y1: 6.62,
    x2: 11.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00479E"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_61942_8511",
    x1: 14.66,
    y1: 6.94,
    x2: 8.89,
    y2: 18.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4A40D4"
  }))));
};
export const OfficePlannerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficePlannerColorIcon({}), 'OfficePlannerColor');
const OfficePlannerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.41 13.03l-1.8-1.76a2.49 2.49 0 001.56-.73l8.6-8.58c.46-.46 1-.72 1.6-.72.58 0 1.12.26 1.58.72L18.3 4.3c.47.46.72 1.01.7 1.6a2.36 2.36 0 01-.76 1.57h-.01l-.54.51-1.42-1.42a2.5 2.5 0 00-3.54 0L6.4 12.91a1.5 1.5 0 01-1.98.12zm1.3 1.28l4.07 4c.44.45 1 .7 1.57.7.58 0 1.13-.25 1.57-.7l5.36-5.25c.43-.44.7-.96.72-1.52.02-.57-.2-1.12-.65-1.56l-2.79-2.71a1.5 1.5 0 00-2.12 0L7.1 13.6c-.4.4-.88.63-1.39.7zm-4.7-5.47c0 .36.07.73.33 1a1.5 1.5 0 002.12 0l4.58-4.59-.57-.56A2.27 2.27 0 005.93 4a2.18 2.18 0 00-1.61.7L1.67 7.3c-.43.44-.67.98-.67 1.55z",
    fill: primaryFill
  }));
};
export const OfficePlannerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficePlannerFilledIcon({}), 'OfficePlannerFilled');
const OfficePlannerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.78 18.32c.44.44 1 .68 1.57.68.58 0 1.13-.24 1.57-.68l5.36-5.26c.43-.44.7-.96.72-1.52.02-.57-.2-1.12-.65-1.56L17 8.63l1.23-1.15v-.01c.46-.45.75-.99.77-1.57a2.13 2.13 0 00-.7-1.6l-2.58-2.57c-.46-.46-1-.73-1.6-.73-.58 0-1.12.27-1.58.73L8.51 5.7 7.47 4.7A2.27 2.27 0 005.93 4a2.18 2.18 0 00-1.61.7L1.67 7.3c-.43.44-.67.98-.67 1.55 0 .56.24 1.1.67 1.53 2.72 2.64 5.42 5.3 8.11 7.95zM5.1 10.48l8.15-8.04c.32-.32.62-.44.88-.44s.56.12.88.44L17.6 5c.3.3.41.6.4.85 0 .26-.14.57-.46.9l-1.25 1.16-.75-.74a2.37 2.37 0 00-3.33.05L7.09 12.4c-.48.48-1.34.49-1.88.02L3.98 11.2c.35-.11.73-.33 1.12-.72zm2.7 2.62l5.12-5.17c.53-.54 1.42-.55 1.91-.05l2.81 2.8c.27.28.37.56.36.82a1.3 1.3 0 01-.42.85l-5.36 5.26c-.28.27-.58.4-.87.4-.28 0-.59-.13-.86-.4l-3.94-3.87c.46-.08.9-.28 1.25-.64zm0-6.68L4.4 9.77c-.53.52-.93.55-1.14.51C2.69 10.2 2 9.42 2 8.84c0-.28.11-.57.38-.83l2.64-2.6V5.4c.3-.3.61-.41.89-.4.28 0 .58.13.86.4l1.02 1.02z",
    fill: primaryFill
  }));
};
export const OfficePlannerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficePlannerRegularIcon({}), 'OfficePlannerRegular');
const OfficePowerPointColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8l10 2.36L10 2z",
    fill: "#ED6C47"
  }), React.createElement("path", {
    d: "M10 2v8l4 2.59L18 10a8 8 0 00-8-8z",
    fill: "#FF8F6B"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 01-16 0h16z",
    fill: "#D35230"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M12 6H3.08a8 8 0 001.65 10H11a2 2 0 002-2V7a1 1 0 00-1-1z",
    fill: "#000"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M12 6H3.08a8 8 0 001.65 10H11a2 2 0 002-2V7a1 1 0 00-1-1z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 5H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: "#C43E1C"
  }), React.createElement("path", {
    d: "M7.33 7c.56-.04 1.12.13 1.56.48a1.78 1.78 0 01.54 1.4c0 .35-.1.7-.26 1-.18.3-.45.55-.76.71a2.5 2.5 0 01-1.15.25H6.18V13h-1.1V7h2.25zm-1.15 3h1c.3 0 .58-.1.8-.3a1 1 0 00.28-.78c0-.66-.36-1-1.09-1h-1L6.18 10z",
    fill: "#fff"
  }));
};
export const OfficePowerPointColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficePowerPointColorIcon({}), 'OfficePowerPointColor');
const OfficePowerPointMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.97 9.24c-.03.1-.09.2-.16.27a1 1 0 01-.68.2h-.7V8.18h.74c.74 0 .84.37.84.74.01.1 0 .21-.04.32z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6.54 2.79A8 8 0 113.76 15H3a1 1 0 01-1-1V6a1 1 0 011-1h.76a8 8 0 012.78-2.21zm8.75 2.63A7 7 0 0011 3.08V5a1 1 0 011 1v4h5a7 7 0 00-1.71-4.58zM10 5v-2a7 7 0 00-4.92 2H10zM7.33 6.75H4.82v6.5h1.61v-2.12h.83c.44 0 .87-.1 1.26-.28a2 2 0 00.86-.81c.2-.36.3-.76.3-1.17a2 2 0 00-.6-1.58c-.5-.4-1.12-.58-1.75-.54zm-2.21 8.24a7 7 0 009.46.29 7 7 0 002.34-4.29H12v3a1 1 0 01-1 1H5.12z",
    fill: primaryFill
  }));
};
export const OfficePowerPointMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficePowerPointMonoIcon({}), 'OfficePowerPointMono');
const OfficeSharepointColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 11.5a4.75 4.75 0 100-9.5 4.75 4.75 0 000 9.5z",
    fill: "#036C70"
  }), React.createElement("path", {
    d: "M14 15a4 4 0 100-8 4 4 0 000 8z",
    fill: "#1A9BA1"
  }), React.createElement("path", {
    d: "M10 18a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z",
    fill: "#37C6D0"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M12 6H4.82a4.75 4.75 0 004.68 5.5 3 3 0 00.42-.05v.05A3.25 3.25 0 006.99 16h4a2 2 0 002-2V7A1 1 0 0012 6z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 5H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: "#038387"
  }), React.createElement("path", {
    d: "M5.52 9.89c-.23-.16-.4-.34-.52-.55a1.5 1.5 0 01-.19-.76c0-.39.12-.72.34-.98a2 2 0 01.9-.59c.38-.13.79-.19 1.23-.19.69 0 1.23.08 1.62.23v1.14a2.55 2.55 0 00-.73-.3c-.28-.07-.56-.1-.86-.1-.35 0-.65.06-.88.19-.23.12-.35.3-.35.53 0 .14.05.26.15.37.1.1.23.2.4.29a12.88 12.88 0 00.85.37c.4.16.71.31.95.46.24.15.42.34.56.57.13.22.2.5.2.84 0 .42-.1.76-.32 1.02-.21.27-.5.46-.85.57-.35.12-.76.18-1.2.18-.4 0-.76-.03-1.1-.09a3.74 3.74 0 01-.9-.26v-1.2a3.5 3.5 0 001.9.59c.4 0 .7-.07.9-.2.2-.13.3-.3.3-.54 0-.16-.06-.3-.17-.41a1.74 1.74 0 00-.47-.33l-.88-.4a5 5 0 01-.88-.45z",
    fill: "#fff"
  }));
};
export const OfficeSharepointColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeSharepointColorIcon({}), 'OfficeSharepointColor');
const OfficeSharepointMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.24 7.01v-.26A4.75 4.75 0 005.04 5h-2a1 1 0 00-1 1v8a1 1 0 001 1h3.72a3.25 3.25 0 006.48-.07c.25.04.5.07.76.07a4 4 0 00.24-8v.01zm-4.74-4a3.75 3.75 0 013.75 4.07 4 4 0 00-1.21.46V6a1 1 0 00-1-1H6.18A3.77 3.77 0 019.5 3v.01zM5.74 13.37a3.78 3.78 0 01-.93-.28l-.14-.07v-1.88l.4.3a3.13 3.13 0 001.7.55c.26.01.51-.04.74-.16a.35.35 0 00.18-.33.31.31 0 00-.1-.24 1.22 1.22 0 00-.39-.28c-.2-.1-.47-.23-.84-.39-.32-.14-.62-.3-.91-.49a1.79 1.79 0 01-.8-1.53c-.01-.42.13-.83.39-1.15.27-.31.61-.54 1-.67a4.76 4.76 0 013 .04l.16.06v1.79l-.39-.25a2.88 2.88 0 00-1.42-.37c-.27 0-.54.07-.78.21a.33.33 0 00-.21.32.28.28 0 00.08.21c.09.1.2.17.31.23l.72.24a5.36 5.36 0 011.07.53 1.85 1.85 0 01.85 1.65 1.91 1.91 0 01-1.34 1.86c-.4.13-.83.2-1.26.19-.37 0-.73-.03-1.09-.09zm4.3 3.63a2.25 2.25 0 01-2.24-2h3.24a1 1 0 001-1v-.27a2.25 2.25 0 01-2 3.27zm4-3c-.3 0-.6-.05-.88-.14a3.21 3.21 0 00-1.12-1.63V8.78a3.08 3.08 0 012-.78 3 3 0 11-.08 6h.08z",
    fill: primaryFill
  }));
};
export const OfficeSharepointMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeSharepointMonoIcon({}), 'OfficeSharepointMono');
const OfficeSkypeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.47 10.91a6.43 6.43 0 00-1.84-5.45 6.56 6.56 0 00-4.61-1.89H9.3A4.07 4.07 0 007.13 3a4.14 4.14 0 00-3.57 2.02 4.04 4.04 0 00-.01 4.08 6.4 6.4 0 002.12 5.77 6.53 6.53 0 005.11 1.56 4.15 4.15 0 005-.62 4.07 4.07 0 00.69-4.9z",
    fill: "#28A8EA"
  }), React.createElement("path", {
    d: "M8.25 9.87a2 2 0 01-.64-.67c-.15-.29-.23-.6-.22-.93-.02-.43.12-.84.39-1.17.27-.31.61-.55 1-.69a4.84 4.84 0 012.86.01c.18.06.35.17.48.31.1.11.15.26.15.41 0 .16-.05.32-.15.44a.54.54 0 01-.4.16.8.8 0 01-.3-.06c-.23-.1-.46-.2-.7-.26a2.37 2.37 0 00-.64-.04c-.3-.01-.6.06-.85.21a.73.73 0 00-.34.63c0 .17.07.33.19.45.13.14.3.26.47.34.2.1.5.23.89.39h.13c.38.15.75.34 1.09.56.27.18.5.42.68.7.17.3.26.65.24 1 .02.41-.1.82-.34 1.16a2 2 0 01-.94.7c-.45.16-.94.24-1.42.23-.67.02-1.33-.1-1.94-.36-.16-.07-.3-.18-.4-.31a.75.75 0 01-.1-.66.52.52 0 01.35-.3.57.57 0 01.22-.02c.18 0 .36.05.52.13l.46.23a3.19 3.19 0 00.92.18c.3.02.62-.06.87-.24a.76.76 0 00.29-.63.67.67 0 00-.18-.46 2 2 0 00-.54-.39c-.24-.13-.57-.28-1-.46a6.14 6.14 0 01-1.1-.57",
    fill: "#fff"
  }));
};
export const OfficeSkypeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeSkypeColorIcon({}), 'OfficeSkypeColor');
const OfficeSkypeMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.52 9.2a2 2 0 00.65.66v.02c.35.23.72.42 1.11.57.43.18.77.33 1 .46.21.1.4.23.55.4.12.12.19.28.19.45a.75.75 0 01-.3.63 1.4 1.4 0 01-.88.24 3.25 3.25 0 01-.93-.18l-.46-.23a1.27 1.27 0 00-.52-.13.58.58 0 00-.43.13.52.52 0 00-.18.43c0 .15.05.3.13.42.11.14.25.24.4.31.63.26 1.3.38 1.96.36.5.01.98-.06 1.44-.23.38-.13.7-.38.95-.7.24-.34.36-.74.34-1.16.02-.35-.07-.7-.24-1-.18-.28-.41-.51-.69-.7a6.16 6.16 0 00-1.1-.56h-.13c-.4-.16-.7-.28-.9-.38a1.6 1.6 0 01-.47-.34.64.64 0 01-.2-.45.72.72 0 01.35-.63c.26-.15.56-.22.86-.21.21-.02.43 0 .64.04.24.06.48.15.7.26.1.04.2.06.31.06a.55.55 0 00.4-.16c.11-.13.16-.28.16-.44 0-.15-.05-.3-.15-.41-.14-.15-.3-.25-.49-.31A4.93 4.93 0 008.7 6.4c-.39.14-.73.38-1 .69-.28.32-.42.74-.4 1.17 0 .32.07.64.22.93z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5.07 3.54A4.14 4.14 0 017.13 3c.77-.02 1.52.18 2.18.57h.7c1.74 0 3.4.68 4.62 1.9a6.43 6.43 0 011.84 5.45 4.07 4.07 0 01-.68 4.88 4.15 4.15 0 01-5 .63 6.57 6.57 0 01-6.75-3.75 6.4 6.4 0 01-.5-3.58 4.04 4.04 0 011.53-5.56zm3.7.92A3.15 3.15 0 004.23 5.9c-.15.38-.23.78-.23 1.19-.01.52.12 1.03.36 1.49l.18.3v.34c-.05.26-.07.53-.07.8.02 1.43.62 2.8 1.66 3.8a5.56 5.56 0 003.89 1.56h1l.27.24a3.13 3.13 0 003.75-.45 3.07 3.07 0 00.54-3.7l-.17-.3.05-.34a5.35 5.35 0 00-3.17-5.73 5.5 5.5 0 00-2.3-.47c-.2-.02-.4-.02-.59 0h-.34l-.3-.18z",
    fill: primaryFill
  }));
};
export const OfficeSkypeMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeSkypeMonoIcon({}), 'OfficeSkypeMono');
const OfficeVisioColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 14h6a1 1 0 001-1V7a1 1 0 00-1-1h-6a1 1 0 00-1 1v6a1 1 0 001 1",
    fill: "#2B7CD3"
  }), React.createElement("path", {
    d: "M10.3 9.7l-3-3a1 1 0 010-1.4l3-3a1 1 0 011.4 0l3 3a1 1 0 010 1.4l-3 3a1 1 0 01-1.4 0",
    fill: "#41A5EE"
  }), React.createElement("path", {
    d: "M15 14a4 4 0 10-8 0 4 4 0 008 0",
    fill: "#103F91"
  }), React.createElement("path", {
    d: "M12 6H7c0 .26.1.51.3.7L10 9.41v.72A4 4 0 007.54 16H11a2 2 0 002-2V7a1 1 0 00-1-1",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 15H3a1 1 0 01-1-1V6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1",
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M6.7 10.97c.17.5.27.81.3.95h.02c.03-.14.14-.47.33-1.02L8.69 7h1.23l-2.27 6H6.33L4.08 7h1.27l1.35 3.97z",
    fill: "#fff"
  }));
};
export const OfficeVisioColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeVisioColorIcon({}), 'OfficeVisioColor');
const OfficeVisioMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.15 13.25l-2.43-6.5h1.8l1.49 4.37 1.5-4.37h1.77l-2.46 6.5H6.15zM11 3l3 3-2 2V6a1 1 0 00-1-1H9l2-2zm6 4v6h-2.14A3.98 3.98 0 0012 10.14v-.73L14.41 7H17zm-6 10a3 3 0 01-2.82-2H11a1 1 0 001-1v-2.82A3 3 0 0111 17zm-8-2h4.14A4 4 0 0015 14h2a1 1 0 001-1V7a1 1 0 00-1-1h-2a1 1 0 00-.3-.7l-3-3a1 1 0 00-1.4 0L7.59 5H3a1 1 0 00-1 1v8a1 1 0 001 1z",
    fill: primaryFill,
    fillRule: "nonzero"
  }));
};
export const OfficeVisioMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeVisioMonoIcon({}), 'OfficeVisioMono');
const OfficeWordColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("rect", {
    x: 5,
    y: 2,
    width: 13,
    height: 16,
    rx: 2,
    fill: "#41A5EE"
  }), React.createElement("path", {
    d: "M5 6h13v4H5V6z",
    fill: "#2B7CD3"
  }), React.createElement("path", {
    d: "M5 10h13v4H5v-4z",
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M5 14h13v2a2 2 0 01-2 2H7a2 2 0 01-2-2v-2z",
    fill: "#103F91"
  }), React.createElement("path", {
    d: "M5 6h7a1 1 0 011 1v7a2 2 0 01-2 2H5V6z",
    fill: "#000",
    fillOpacity: 0.5
  }), React.createElement("rect", {
    x: 2,
    y: 5,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M11.06 7l-1.64 6H8.26L7.15 8.88a3.28 3.28 0 01-.1-.64h-.02a3.83 3.83 0 01-.1.64L5.78 13H4.61L2.94 7h1.12l1.06 4.3a5.45 5.45 0 01.1.64h.01a3.52 3.52 0 01.13-.65L6.56 7h1.07l1.13 4.34a3.08 3.08 0 01.1.6h.01a2.95 2.95 0 01.1-.62L10 7h1.06z",
    fill: "#fff"
  }));
};
export const OfficeWordColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeWordColorIcon({}), 'OfficeWordColor');
const OfficeWordFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2h6a2 2 0 011.73 1H18V4a2 2 0 00-2-2H7zm0 16a2 2 0 01-2-2h6a2 2 0 001.73-1H18v1a2 2 0 01-2 2H7zm11-4h-5v-3.5h5V14zm0-4.5h-5V6h5v3.5zM2 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V6zm9.06 1H10L8.97 11.3a13.98 13.98 0 00-.1.63h-.02a4.5 4.5 0 00-.1-.6L7.64 7H6.57l-1.21 4.3a6.23 6.23 0 00-.13.65h-.02a5.46 5.46 0 00-.09-.65L4.06 7H2.94l1.67 6h1.18l1.13-4.12a3.02 3.02 0 00.11-.64h.02a3.24 3.24 0 00.1.64L8.26 13h1.16l1.64-6z",
    fill: primaryFill
  }));
};
export const OfficeWordFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeWordFilledIcon({}), 'OfficeWordFilled');
const OfficeWordMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 15v2a1 1 0 001 1h11a1 1 0 001-1V3a1 1 0 00-1-1H6a1 1 0 00-1 1v2H3a1 1 0 00-1 1v8a1 1 0 001 1h2zm7-4h5v3h-5v-3zm0-1V7h5v3h-5zm-6 7v-2h11v2H6zM6 3h11v3h-5a1 1 0 00-1-1H6V3zm1.83 10.25l-.84-3.74-.8 3.74H4.51l-1.43-6.5h1.6l.73 3.73.81-3.73H7.8l.85 3.71.68-3.71h1.59l-1.43 6.5H7.83z",
    fill: primaryFill
  }));
};
export const OfficeWordMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeWordMonoIcon({}), 'OfficeWordMono');
const OfficeWordRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h9a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2h1a1 1 0 001 1h9a1 1 0 001-1v-2h-4v-1h4v-2.5h-4v-1h4V7h-4V6h4V4a1 1 0 00-1-1H7a1 1 0 00-1 1H5zM2 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V6zm9.06 1H10L8.97 11.3a13.98 13.98 0 00-.1.63h-.02a4.5 4.5 0 00-.1-.6L7.64 7H6.57l-1.21 4.3a6.23 6.23 0 00-.13.65h-.02a5.46 5.46 0 00-.09-.65L4.06 7H2.94l1.67 6h1.18l1.13-4.12a3.02 3.02 0 00.11-.64h.02a3.24 3.24 0 00.1.64L8.26 13h1.16l1.64-6z",
    fill: primaryFill
  }));
};
export const OfficeWordRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeWordRegularIcon({}), 'OfficeWordRegular');
const OfficeYammerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.99 8.82c-.06-.21-.13-.46-.21-.66a4.94 4.94 0 00-.93-1.4.18.18 0 01-.01-.08.19.19 0 01.06-.15l4.36-4.41a.43.43 0 01.62 0c1.3 1.4 2.22 3.1 2.7 4.94l-3.41 2.59-3.18-.83z",
    fill: "#28A8EA"
  }), React.createElement("path", {
    d: "M17.64 6.99a.42.42 0 00-.56-.31L8.99 8.82a4.76 4.76 0 010 2.4l3 1.8 3.58-.08 1.54.4a.42.42 0 00.52-.3c.48-1.97.48-4.03 0-6l.01-.05z",
    fill: "#0F78D4"
  }), React.createElement("path", {
    d: "M8.99 11.2c-.06.21-.13.46-.21.66-.22.5-.51.96-.88 1.36a.22.22 0 000 .3l4.36 4.35a.42.42 0 00.62 0c1.3-1.4 2.22-3.1 2.7-4.94L8.99 11.2z",
    fill: "#0358A7"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M13 14V7a1 1 0 00-1-1H8.38l-.49.49a.21.21 0 000 .26 4.88 4.88 0 011.1 4.47c-.06.21-.13.46-.21.66-.22.5-.51.96-.88 1.36a.22.22 0 000 .3l2.48 2.48H11A2 2 0 0013 14z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 5H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: "#0078D4"
  }), React.createElement("path", {
    d: "M6.53 9.54c.06.12.1.25.14.38.03-.13.07-.25.13-.37l1.28-2.39a.58.58 0 01.5-.34.56.56 0 01.5.88L7.3 10.75a.68.68 0 00-.07.28v1.55a.56.56 0 01-.56.56h-.11a.56.56 0 01-.56-.56v-1.53a.52.52 0 00-.07-.23L4.21 7.69a.56.56 0 01.48-.87h.11a.58.58 0 01.5.3l1.23 2.42z",
    fill: "#fff"
  }));
};
export const OfficeYammerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeYammerColorIcon({}), 'OfficeYammerColor');
const OfficeYammerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 2.15a.5.5 0 00-.7 0L10.29 4H11a2 2 0 012 2v.54l2.2-.6c-.7-1.8-1.7-3.15-2.35-3.8zm-.7 15.7L10.29 16H11a2 2 0 002-2v-.54l2.2.6c-.7 1.8-1.7 3.15-2.35 3.8a.5.5 0 01-.7 0zm.85-5.42V7.57l3.87-1.05a.5.5 0 01.6.32l.03.08c.18.54.5 1.48.5 3.08a11.29 11.29 0 01-.38 2.84c-.03.1-.06.19-.1.26a.9.9 0 01-.17.25.5.5 0 01-.48.13L13 12.43zM2 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V6zm7.28 1.82a.83.83 0 000-.78.82.82 0 00-1.42 0L6.67 9.28 5.52 7.1a.8.8 0 00-.73-.5h-.1a.78.78 0 00-.7.4.79.79 0 000 .8l1.76 3.15c.02.05.02.1 0 .15v1.47a.81.81 0 00.81.8h.15a.81.81 0 00.81-.8v-1.54a.32.32 0 010-.16l1.76-3.05z",
    fill: primaryFill
  }));
};
export const OfficeYammerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeYammerFilledIcon({}), 'OfficeYammerFilled');
const OfficeYammerMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 2.15a.5.5 0 00-.7 0L9.29 5H3a1 1 0 00-1 1v8a1 1 0 001 1h6.3l2.85 2.85c.2.2.5.2.7 0 .75-.75 2-2.46 2.68-4.73l1.34.36a.5.5 0 00.48-.13.9.9 0 00.17-.25 5.93 5.93 0 00.28-.97c.11-.56.2-1.3.2-2.13 0-1.6-.32-2.54-.5-3.08l-.03-.08a.5.5 0 00-.6-.32l-1.34.36a11.95 11.95 0 00-2.68-4.73zM10.71 15H11a1 1 0 001-1v-1.85l2.57.7a11.41 11.41 0 01-2.09 3.93L10.71 15zM12 11.12V8.88l4.67-1.27c.16.5.33 1.26.33 2.39a10.28 10.28 0 01-.29 2.4L12 11.12zm0-3.27V6a1 1 0 00-1-1h-.3l1.78-1.78c.67.79 1.56 2.18 2.09 3.93l-2.57.7zm-2.72-.03l-1.76 3.05a.32.32 0 000 .16v1.54a.81.81 0 01-.8.8h-.16a.81.81 0 01-.8-.8V11.1a.24.24 0 000-.15L3.98 7.8A.79.79 0 014 7a.78.78 0 01.7-.4h.1a.8.8 0 01.73.49l1.15 2.18 1.2-2.24a.82.82 0 011.41 0 .83.83 0 010 .78z",
    fill: primaryFill
  }));
};
export const OfficeYammerMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeYammerMonoIcon({}), 'OfficeYammerMono');
const PanelLeftLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v7a3 3 0 003 3h4v-1h-.5V5H15a2 2 0 012 2v2.6c.36.18.7.4 1 .66V7a3 3 0 00-3-3H5z",
    fill: primaryFill
  }));
};
export const PanelLeftLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftLoopFilledIcon({}), 'PanelLeftLoopFilled');
const PanelLeftLoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v3.26a5.5 5.5 0 00-1-.66V7a2 2 0 00-2-2H8.5v11H9v1H5a3 3 0 01-3-3V7zm3-2a2 2 0 00-2 2v7c0 1.1.9 2 2 2h2.5V5H5z",
    fill: primaryFill
  }));
};
export const PanelLeftLoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftLoopRegularIcon({}), 'PanelLeftLoopRegular');
const PlacesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79 17.99V4.65h6.36a6.97 6.97 0 01-.79 7.85l-4.22 4.97A1.5 1.5 0 019.8 18z",
    fill: "url(#paint0_radial_0_165)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18V8.5a3.5 3.5 0 017-.2V8a7 7 0 10-12.36 4.5l4.22 4.97c.3.36.72.53 1.14.53z",
    fill: "url(#paint1_radial_0_165)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18V8.5a3.5 3.5 0 017-.2V8a7 7 0 10-12.36 4.5l4.22 4.97c.3.36.72.53 1.14.53z",
    fill: "url(#paint2_linear_0_165)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_0_165",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-69.78 17.9 1.84) scale(13.7978 7.50958)"
  }, React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D59DFF"
  }), React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0078D4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0C59A4"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_0_165",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.33492 5.08542 -6.85585 16.62918 3.72 5.07)"
  }, React.createElement("stop", {
    stopColor: "#43EFB1"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#21C6B3"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1E8FCF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_0_165",
    x1: 14.08,
    y1: 24.77,
    x2: 1.53,
    y2: 14.44,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A194F4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#975ECE",
    stopOpacity: 0
  }))));
};
export const PlacesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlacesColorIcon({}), 'PlacesColor');
const PlacesMonoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 9a7 7 0 0113.57-2.43A4.25 4.25 0 009.5 9.75v9.15a1.5 1.5 0 01-.64-.44l-3.98-4.69A6.98 6.98 0 013 9zm7.5 9.9c.24-.08.46-.23.64-.44l3.98-4.69a7 7 0 001.57-2.72c.32-1.04.36-2.23-.25-3.13a3.25 3.25 0 00-5.94 1.83v9.15z",
    fill: "#242424"
  }));
};
export const PlacesMonoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlacesMonoFilledIcon({}), 'PlacesMonoFilled');
const PlacesMonoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 9a6 6 0 0111.1-3.17A3.99 3.99 0 009.5 9.5v8.17L5.63 13.1l-.01-.01A5.98 5.98 0 014 9zm6.5 8.67V9.5a3 3 0 015.34-1.88 6.02 6.02 0 01-1.46 5.48l-3.88 4.57zM10 2a7 7 0 00-5.12 11.77l3.98 4.69c.6.7 1.68.7 2.28 0l3.98-4.69A7 7 0 0010 2z",
    fill: "#242424"
  }));
};
export const PlacesMonoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlacesMonoRegularIcon({}), 'PlacesMonoRegular');
const ProjectColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a1 1 0 011-1h8a1 1 0 011 1v4H4V4z",
    fill: "#33C481"
  }), React.createElement("path", {
    d: "M4 8h11a1 1 0 011 1v3H4V8z",
    fill: "#21A366"
  }), React.createElement("path", {
    d: "M8 12h9a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-4z",
    fill: "#185C37"
  }), React.createElement("path", {
    opacity: 0.6,
    d: "M8 6h4.25c.41 0 .75.34.75.75v7.75c0 .83-.67 1.5-1.5 1.5H8V6z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11.17 5H2.83a.83.83 0 00-.83.83v8.34c0 .46.37.83.83.83h8.34c.46 0 .83-.37.83-.83V5.83a.83.83 0 00-.83-.83z",
    fill: "#107C41"
  }), React.createElement("path", {
    d: "M7.4 7a2.5 2.5 0 011.65.49 1.73 1.73 0 01.57 1.4c0 .33-.1.66-.28.94-.2.31-.48.56-.8.72-.39.17-.8.26-1.22.25H6.17V13H5V7h2.4zM6.17 9.82H7.2c.32.03.63-.07.89-.26a.66.66 0 00.3-.62c0-.66-.39-1-1.16-1H6.17v1.88z",
    fill: "#fff"
  }));
};
export const ProjectColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProjectColorIcon({}), 'ProjectColor');
const ProjectMonoIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 4v3h-1V5.83a.83.83 0 00-.83-.83H5V4h8zM4 4v1H2.83a.83.83 0 00-.83.83v8.34c0 .46.37.83.83.83H8v1a1 1 0 001 1h8a1 1 0 001-1v-3a1 1 0 00-1-1h-1V8a1 1 0 00-1-1h-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1zm5 12v-1h2.17c.46 0 .83-.37.83-.83V13h5v3H9zm6-4h-3V8h3v4zM9.05 7.49a1.73 1.73 0 01.57 1.4c0 .33-.1.66-.28.94-.2.31-.48.56-.8.72-.39.17-.8.26-1.22.25H6.17V13H5V7h2.4a2.5 2.5 0 011.65.49zM7.19 9.8H6.17V7.94h1.05c.77 0 1.16.33 1.16 1a.66.66 0 01-.3.6c-.26.2-.57.3-.9.27z",
    fill: primaryFill
  }));
};
export const ProjectMono = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProjectMonoIcon({}), 'ProjectMono');
const SparkleColorColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.54 16.85a.8.8 0 001.22-.4l.25-.76a1.09 1.09 0 01.68-.68l.77-.25a.8.8 0 00-.02-1.52l-.77-.25a1.08 1.08 0 01-.68-.68l-.25-.77a.8.8 0 00-1.52.01l-.24.76a1.1 1.1 0 01-.67.68l-.77.25a.8.8 0 000 1.52l.77.25a1.09 1.09 0 01.68.68l.25.77c.06.16.16.3.3.4z",
    fill: "url(#paint0_linear_2036_11077)"
  }), React.createElement("path", {
    d: "M13.54 16.85a.8.8 0 001.22-.4l.25-.76a1.09 1.09 0 01.68-.68l.77-.25a.8.8 0 00-.02-1.52l-.77-.25a1.08 1.08 0 01-.68-.68l-.25-.77a.8.8 0 00-1.52.01l-.24.76a1.1 1.1 0 01-.67.68l-.77.25a.8.8 0 000 1.52l.77.25a1.09 1.09 0 01.68.68l.25.77c.06.16.16.3.3.4z",
    fill: "url(#paint1_radial_2036_11077)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M13.54 16.85a.8.8 0 001.22-.4l.25-.76a1.09 1.09 0 01.68-.68l.77-.25a.8.8 0 00-.02-1.52l-.77-.25a1.08 1.08 0 01-.68-.68l-.25-.77a.8.8 0 00-1.52.01l-.24.76a1.1 1.1 0 01-.67.68l-.77.25a.8.8 0 000 1.52l.77.25a1.09 1.09 0 01.68.68l.25.77c.06.16.16.3.3.4z",
    fill: "url(#paint2_radial_2036_11077)"
  }), React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 001.59-.51l.45-1.37a2.34 2.34 0 011.47-1.48l1.4-.45A1.04 1.04 0 0012.25 7l-1.37-.45A2.34 2.34 0 019.4 5.08L8.95 3.7a1.03 1.03 0 00-.82-.68 1.04 1.04 0 00-1.15.7l-.46 1.4a2.34 2.34 0 01-1.44 1.45L3.7 7a1.04 1.04 0 00.02 1.97l1.37.45a2.33 2.33 0 011.48 1.48l.46 1.4c.07.2.2.37.38.5z",
    fill: "url(#paint3_linear_2036_11077)"
  }), React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 001.59-.51l.45-1.37a2.34 2.34 0 011.47-1.48l1.4-.45A1.04 1.04 0 0012.25 7l-1.37-.45A2.34 2.34 0 019.4 5.08L8.95 3.7a1.03 1.03 0 00-.82-.68 1.04 1.04 0 00-1.15.7l-.46 1.4a2.34 2.34 0 01-1.44 1.45L3.7 7a1.04 1.04 0 00.02 1.97l1.37.45a2.33 2.33 0 011.48 1.48l.46 1.4c.07.2.2.37.38.5z",
    fill: "url(#paint4_radial_2036_11077)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 001.59-.51l.45-1.37a2.34 2.34 0 011.47-1.48l1.4-.45A1.04 1.04 0 0012.25 7l-1.37-.45A2.34 2.34 0 019.4 5.08L8.95 3.7a1.03 1.03 0 00-.82-.68 1.04 1.04 0 00-1.15.7l-.46 1.4a2.34 2.34 0 01-1.44 1.45L3.7 7a1.04 1.04 0 00.02 1.97l1.37.45a2.33 2.33 0 011.48 1.48l.46 1.4c.07.2.2.37.38.5z",
    fill: "url(#paint5_radial_2036_11077)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_2036_11077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.33436 -1.33339 2.02 2.02147 11.66 16.5)"
  }, React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5178C9"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3E74C7",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_2036_11077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.33665 4.66686 -8.01634 7.44914 11.5 11.5)"
  }, React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C69FFF"
  }), React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C096FF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint4_radial_2036_11077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.89399 -2.76243 4.1849 4.38421 3.4 12.21)"
  }, React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5178C9"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3E74C7",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_2036_11077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -3.17 7.98) scale(8.92954 15.3377)"
  }, React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C69FFF"
  }), React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C096FF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_2036_11077",
    x1: 12.66,
    y1: 12.17,
    x2: 17.16,
    y2: 17.34,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BA6DF1"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7376E1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4B9DF5"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_2036_11077",
    x1: 4.97,
    y1: 4.71,
    x2: 12.34,
    y2: 12.34,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C67EFF"
  }), React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7376E1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F6CBD"
  }))));
};
export const SparkleColorColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/SparkleColorColorIcon({}), 'SparkleColorColor');
const StickyNotesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 3C3.78 3 3 3.78 3 4.75v10.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75V4.75C17 3.78 16.22 3 15.25 3H4.75z",
    fill: "#FFC424"
  }), React.createElement("path", {
    d: "M4.75 3C3.78 3 3 3.78 3 4.75v10.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75V4.75C17 3.78 16.22 3 15.25 3H4.75z",
    fill: "url(#paint0_radial_58452_140817)"
  }), React.createElement("path", {
    d: "M17 5.33C17 7.82 10.1 17 8.53 17c.78 0 .5-1.94.25-2.9l-.47-1.8c-.22-.82.2-1.68 1-1.97 3.1-1.11 7.08-1.54 7.69-5z",
    fill: "url(#paint1_linear_58452_140817)"
  }), React.createElement("path", {
    d: "M3 4.75C3 3.78 3.78 3 4.75 3h10.5c.97 0 1.75.78 1.75 1.75v.58c-.5 2.8-3.2 3.61-5.84 4.41-.63.19-1.25.38-1.84.6A1.64 1.64 0 008.3 12.3l.47 1.8c.24.92.51 2.77-.18 2.88h-.04l-.03.01H4.75C3.78 17 3 16.22 3 15.25V4.75z",
    fill: "url(#paint2_linear_58452_140817)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint1_linear_58452_140817",
    x1: 8.71,
    y1: 8.79,
    x2: 14.74,
    y2: 13.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C86FEC"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9427C3"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_58452_140817",
    x1: 13.04,
    y1: 11.64,
    x2: 3.49,
    y2: 3.66,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFDC57"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFC424"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB152"
  })), React.createElement("radialGradient", {
    id: "paint0_radial_58452_140817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.49999 7.99998 -16.62326 25.9739 8.38 10.5)"
  }, React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A43303"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFC525",
    stopOpacity: 0
  }))));
};
export const StickyNotesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickyNotesColorIcon({}), 'StickyNotesColor');
const StickyNotesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8c.5 0 .96.12 1.37.33 1.48.97 1.06 3.96-.95 4.72-.95.35-2 .6-3.05.83-.9.2-1.81.42-2.67.7a2.48 2.48 0 00-1.61 3c.07.24.22.55.38.91.54 1.17 1.27 2.76.23 3.51H6a3 3 0 01-3-3V6zm5.84 11H14a3 3 0 003-3V6.9l-.02.04c-1.27 3.9-5.39 9.15-8.14 10.06z",
    fill: primaryFill
  }));
};
export const StickyNotesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickyNotesFilledIcon({}), 'StickyNotesFilled');
const StickyNotesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3.19V14a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm13 .07V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8c0 1.1.9 2 2 2h2.04a.24.24 0 00.08-.07c.02-.04.05-.1.06-.21.02-.23-.05-.56-.2-.96-.13-.4-.32-.8-.5-1.17l-.03-.07c-.15-.33-.3-.67-.37-.9-.3-1.17.27-2.55 1.47-2.98.91-.33 1.86-.55 2.74-.75l.35-.08c.76-.17 1.46-.32 2.08-.52.72-.23 1.27-.5 1.65-.86.35-.32.57-.75.63-1.36zM10.58 16H14a2 2 0 002-2V9.18a23.08 23.08 0 01-2.15 3.42 18.36 18.36 0 01-3.27 3.4z",
    fill: primaryFill
  }));
};
export const StickyNotesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickyNotesRegularIcon({}), 'StickyNotesRegular');
const StreamColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.06 10v5.56c0 1.14 1.32 1.83 2.32 1.2l8.94-5.55c.45-.29.68-.75.68-1.21l-5.97-1-5.97 1z",
    fill: "url(#paint0_linear_53046_136107)"
  }), React.createElement("path", {
    d: "M8.37 3.23c-1-.61-2.3.07-2.3 1.21V10H18c0-.46-.23-.92-.68-1.2L8.38 3.22z",
    fill: "url(#paint1_linear_53046_136107)"
  }), React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 12,
    height: 14
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06 4.44c0-1.14 1.31-1.82 2.31-1.2l8.94 5.55c.46.3.69.75.69 1.21H6.06V4.44zm0 11.12V10H18c0 .46-.23.92-.69 1.2l-8.93 5.57c-1 .62-2.32-.07-2.32-1.21z",
    fill: "url(#paint2_linear_53046_136107)"
  })), React.createElement("g", {
    filter: "url(#filter0_dd_53046_136107)",
    mask: "url(#a)"
  }, React.createElement("path", {
    d: "M3 6.67c0-.58.68-.92 1.17-.6l5.04 3.34a.7.7 0 010 1.18l-5.04 3.34c-.5.32-1.17-.02-1.17-.6V6.67z",
    fill: "url(#paint3_linear_53046_136107)"
  })), React.createElement("path", {
    d: "M3 6.67c0-.58.68-.92 1.18-.6l5.04 3.34a.7.7 0 010 1.18l-5.04 3.34c-.5.32-1.18-.02-1.18-.6V6.67z",
    fill: "url(#paint4_linear_53046_136107)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_53046_136107",
    x1: 6.06,
    y1: 9.98,
    x2: 6.65,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BD3177"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#832054"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_53046_136107",
    x1: 6.06,
    y1: 2.98,
    x2: 6.66,
    y2: 9.93,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F992CA"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DA3988"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_53046_136107",
    x1: 6.06,
    y1: 2.98,
    x2: 6.66,
    y2: 9.93,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF98E8"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E11275"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_53046_136107",
    x1: 6.27,
    y1: 5.95,
    x2: 6.27,
    y2: 14.05,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9D73CB"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BC1948"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6F99"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_53046_136107",
    x1: 3,
    y1: 5.93,
    x2: 4.42,
    y2: 13.77,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F992CA"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DA3988"
  })), React.createElement("filter", {
    id: "filter0_dd_53046_136107",
    x: 2.66,
    y: 5.61,
    width: 7.9,
    height: 9.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dx: 0.34,
    dy: 0.34
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.34
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53046_136107"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dy: 0.07
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.03
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_53046_136107",
    result: "effect2_dropShadow_53046_136107"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_53046_136107",
    result: "shape"
  }))));
};
export const StreamColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamColorIcon({}), 'StreamColor');
const StreamFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.67 3.26l8.5 5.25c1.1.69 1.1 2.3 0 2.98l-8.5 5.25A1.75 1.75 0 016 15.24v-.48l4.07-2.94a2.25 2.25 0 000-3.64L6 5.24v-.49c0-1.37 1.5-2.2 2.67-1.49zM3 6.76a1.25 1.25 0 011.98-1.02l4.5 3.25c.7.5.7 1.53 0 2.02l-4.5 3.25c-.82.6-1.98 0-1.98-1.01v-6.5z",
    fill: primaryFill
  }));
};
export const StreamFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamFilledIcon({}), 'StreamFilled');
const StreamRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.67 3.26l8.5 5.25c1.1.69 1.1 2.3 0 2.98l-8.5 5.25A1.75 1.75 0 016 15.24v-1.71l-1.02.73c-.82.6-1.98 0-1.98-1.01v-6.5a1.25 1.25 0 011.98-1.01L6 6.47V4.75c0-1.37 1.5-2.2 2.67-1.49zM7 7.2l2.48 1.79c.7.5.7 1.53 0 2.02L7 12.81v2.44c0 .59.65.95 1.15.64l8.5-5.25a.75.75 0 000-1.28l-8.5-5.25A.75.75 0 007 4.75V7.2zm-3-.45v6.5c0 .2.23.32.4.2l4.5-3.25c.13-.1.13-.3 0-.4L4.4 6.55a.25.25 0 00-.4.2z",
    fill: primaryFill
  }));
};
export const StreamRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamRegularIcon({}), 'StreamRegular');
const SyntexColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 12.5c-.14.01-.25.48-.35.6a.6.6 0 00.18.92l8.03 3.89a.97.97 0 00.9-.04l6.6-3.73a.26.26 0 00.06-.4.24.24 0 00-.12-.07l-7-1.4L6.5 12l-4 .5z",
    fill: "#5E438F"
  }), React.createElement("path", {
    d: "M2.5 12.5c-.14.01-.25.48-.35.6a.6.6 0 00.18.92l8.03 3.89a.97.97 0 00.9-.04l6.6-3.73a.26.26 0 00.06-.4.24.24 0 00-.12-.07l-7-1.4L6.5 12l-4 .5z",
    fill: "url(#paint0_linear_1_66)",
    style: {
      mixBlendMode: "multiply"
    }
  }), React.createElement("path", {
    d: "M17.53 4c.18-.08.33-.72.4-.9a.8.8 0 00.03-.57.82.82 0 00-.92-.52L2.41 4.31a.48.48 0 00-.4.48v1.3a.48.48 0 00.31.46l5.06 1.8L13 7l4.53-3z",
    fill: "#159CA2"
  }), React.createElement("path", {
    d: "M17.53 4c.18-.08.33-.72.4-.9a.8.8 0 00.03-.57.82.82 0 00-.92-.52L2.41 4.31a.48.48 0 00-.4.48v1.3a.48.48 0 00.31.46l5.06 1.8L13 7l4.53-3z",
    fill: "url(#paint1_linear_1_66)"
  }), React.createElement("path", {
    d: "M17.55 3.51l-.06.03-10.1 4.8-4.99 2.37-.08.04a.56.56 0 00-.32.5v2.23a.56.56 0 01.52-.56l8.01-.62 6.54-.51.19-.02a.8.8 0 00.74-.8V2.8a.79.79 0 01-.45.71z",
    fill: "#49C9EE"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_1_66",
    x1: 14.01,
    y1: 15.76,
    x2: 2.28,
    y2: 11.27,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5E438F",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5E438F",
    stopOpacity: 0.7
  })), React.createElement("linearGradient", {
    id: "paint1_linear_1_66",
    x1: 1.98,
    y1: 4.25,
    x2: 18.19,
    y2: 5.7,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#066E74",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#066E74"
  }))));
};
export const SyntexColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyntexColorIcon({}), 'SyntexColor');
const SyntexFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.32 6.55l3.73 1.32 11.76-5.59a.82.82 0 00-.76-.27L2.4 4.31A.48.48 0 002 4.8v1.3a.48.48 0 00.32.46zm.08 4.16L6.21 8.9 18 3.3v7.67a.8.8 0 01-.74.8l-.18.02-.94.07L2 12.96v-1.72a.56.56 0 01.32-.5l.08-.04zm-.18 3.25l.1.06 8.04 3.89a.97.97 0 00.9-.04l6.61-3.73a.25.25 0 00.1-.1.26.26 0 00-.04-.3.24.24 0 00-.13-.07L14.4 13l-12.18.97z",
    fill: primaryFill
  }));
};
export const SyntexFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyntexFilledIcon({}), 'SyntexFilled');
const SyntexRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.66 11.77c.22-.23.34-.53.33-.85V3.25a1.23 1.23 0 00-.62-1.08 1.4 1.4 0 00-.85-.17L2.8 4.18a1 1 0 00-.58.32 1 1 0 00-.22.62v1.23a.94.94 0 00.63.89l3.6 1.28-3.65 1.74a1 1 0 00-.58.92v2.09c0 .2.06.38.16.55.1.17.26.3.44.39l7.53 3.64c.19.09.4.14.6.14.23 0 .45-.07.65-.18l6.2-3.5a.84.84 0 00.3-.32c.06-.14.09-.3.06-.44a.66.66 0 00-.19-.39.7.7 0 00-.38-.22l-3-.6 2.44-.19c.32-.01.63-.15.85-.38zM3 6.35V5.17L16.69 3a.29.29 0 01.18 0c.05.03.1.07.12.13a.3.3 0 010 .13.2.2 0 010 .07l-.06.06h-.05L7.51 7.92 3 6.35zm13.52 7.45L10.93 17a.41.41 0 01-.19.05.43.43 0 01-.19 0l-7.5-3.7 7.7-.62 5.77 1.07zm-6-2.14L3 12.23v-1.05l14-6.67v6.41a.24.24 0 01-.07.17.2.2 0 01-.16.08l-6.25.49z",
    fill: primaryFill
  }));
};
export const SyntexRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyntexRegularIcon({}), 'SyntexRegular');
const TableLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M17 10.41a4.98 4.98 0 00-4 0V8h4v2.41z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.42 13a4.98 4.98 0 00-.42 2v2H8v-4h2.42z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 11c-.38.29-.71.62-1 1H8V8h4v3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 8v4H3V8h4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 13H3v1.5A2.5 2.5 0 005.5 17H7v-4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17 7h-4V3h1.5A2.5 2.5 0 0117 5.5V7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 7V3H8v4h4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 7V3H5.5A2.5 2.5 0 003 5.5V7h4z",
    fill: primaryFill
  }));
};
export const TableLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableLoopFilledIcon({}), 'TableLoopFilled');
const TaskListLtrLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M5.85 3.65c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 11.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 5.25c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 018 5.25z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 10.25c0-.41.34-.75.75-.75h8.5a.75.75 0 01.5 1.32A4.98 4.98 0 0012 11H8.75a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.03 14.5H8.75a.75.75 0 000 1.5H10v-1c0-.17.01-.34.03-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5.85 9.15c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5.85 14.85a.5.5 0 00-.7-.7L3.5 15.79l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2z",
    fill: primaryFill
  }));
};
export const TaskListLtrLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListLtrLoopFilledIcon({}), 'TaskListLtrLoopFilled');
const TeamsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7a2 2 0 100-4 2 2 0 000 4zm-3 1a1 1 0 00-1 1v4a3 3 0 106 0V9a1 1 0 00-1-1h-4z",
    fill: "#5059C9"
  }), React.createElement("path", {
    d: "M11.5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM8 8a1 1 0 00-1 1v4.5a4.5 4.5 0 109 0V9a1 1 0 00-1-1H8z",
    fill: "#7B83EB"
  }), React.createElement("path", {
    d: "M12.9 6.57A2.49 2.49 0 019.5 6H12a1 1 0 01.9.57zM13 8H8a1 1 0 00-1 1v4.5c0 .93.28 1.79.76 2.5H11a2 2 0 002-2V8z",
    fill: "#000",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M2 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V6z",
    fill: "#4B53BC"
  }), React.createElement("path", {
    d: "M9.23 7.87H7.51V13H6.49V7.87H4.77V7h4.46v.87z",
    fill: "#fff"
  }));
};
export const TeamsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/TeamsColorIcon({}), 'TeamsColor');
const TeamsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 4.5c0 .82-.4 1.54-1 2V6a2 2 0 00-2-2H9.05a2.5 2.5 0 014.95.5zM11 16H7.76A4.5 4.5 0 0016 13.5V9a1 1 0 00-1-1h-2v6a2 2 0 01-2 2zm8-3a3 3 0 01-2.59 2.97c.38-.74.59-1.58.59-2.47V9a2 2 0 00-.27-1H18a1 1 0 011 1v4zm-2-6a2 2 0 100-4 2 2 0 000 4zM2 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V6zm7.23 1.87V7H4.77v.87h1.72V13H7.5V7.87h1.72z",
    fill: primaryFill
  }));
};
export const TeamsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TeamsFilledIcon({}), 'TeamsFilled');
const TeamsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 4.25c0 .7-.4 1.3-1 1.58V6.9A2.75 2.75 0 108.51 4h1a1.75 1.75 0 013.49.25zM12 9V8h6a1 1 0 011 1v4a3 3 0 01-4.37 2.67 4 4 0 01-7.1.33h1.23A3 3 0 0014 14V9h-2zm2.94 5.7A2 2 0 0018 13V9h-3v5c0 .24-.02.47-.06.7zM18 5a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0zM1 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1V6zm7.23 1.87V7H3.77v.87h1.72V13H6.5V7.87h1.72z",
    fill: primaryFill
  }));
};
export const TeamsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TeamsRegularIcon({}), 'TeamsRegular');
const TextBulletListLtrLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M4.5 5A1.25 1.25 0 112 5a1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.75 4.25a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 10c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-.07a4.98 4.98 0 00-4.36 0H7.75A.75.75 0 017 10z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.1 14.25H7.75a.75.75 0 000 1.5H10v-.5c0-.34.04-.68.1-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3.25 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M4.5 15A1.25 1.25 0 112 15a1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }));
};
export const TextBulletListLtrLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListLtrLoopFilledIcon({}), 'TextBulletListLtrLoopFilled');
const TextNumberListLtrLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M4.61 1.01A.5.5 0 015 1.5v4a.5.5 0 01-1 0V2.92c-.22.2-.48.38-.78.53a.5.5 0 01-.44-.9 2.96 2.96 0 001.2-1.15l.07-.12A.5.5 0 014.61 1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 018 4.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 9.75c0-.41.34-.75.75-.75h7.5a.75.75 0 01.5 1.31 4.99 4.99 0 00-3.93.19H8.75A.75.75 0 018 9.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.1 14H8.75a.75.75 0 000 1.5H10V15c0-.34.04-.68.1-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2.65 8.35a.5.5 0 010-.7v-.01h.01a1.36 1.36 0 01.12-.11A2.5 2.5 0 014.32 7c.38 0 .79.1 1.11.35C5.78 7.6 6 8 6 8.5c0 .55-.24.93-.57 1.2a4.2 4.2 0 01-.96.56c-.3.16-.54.3-.7.47a.93.93 0 00-.18.27H5.5a.5.5 0 110 1H3a.5.5 0 01-.5-.5c0-.62.2-1.08.52-1.44a3.32 3.32 0 011.15-.77c.27-.13.47-.23.62-.35A.5.5 0 005 8.5c0-.18-.07-.28-.16-.35A.93.93 0 004.3 8a1.5 1.5 0 00-.95.35h-.01c-.2.2-.5.2-.7 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M4.25 15a.5.5 0 100 1c.34 0 .53.1.63.18.1.09.13.2.13.3-.01.2-.19.52-.76.52-.41 0-.63-.1-.72-.17a.42.42 0 01-.1-.07.5.5 0 00-.88.46v.01l.02.02a.8.8 0 00.1.15c.07.08.17.17.3.27.28.18.7.33 1.28.33 1.03 0 1.73-.67 1.76-1.48.01-.37-.12-.74-.4-1.02.28-.28.41-.65.4-1.02-.03-.8-.73-1.48-1.76-1.48-.59 0-1 .15-1.28.33a1.4 1.4 0 00-.4.42l-.01.01v.01a.5.5 0 00.87.48.42.42 0 01.1-.08c.1-.07.3-.17.72-.17.57 0 .75.33.76.52 0 .1-.04.21-.13.3-.1.08-.29.18-.63.18zm-.82-.75l.01-.02v.02z",
    fill: primaryFill
  }));
};
export const TextNumberListLtrLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextNumberListLtrLoopFilledIcon({}), 'TextNumberListLtrLoopFilled');
const ToDoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.08 14.6l2.1 2.1c.2.2.46.3.72.3a1 1 0 00.7-.3l2.1-2.1a1 1 0 00.08-.07L17.7 7.6a1 1 0 000-1.42L16.3 4.8a1 1 0 00-1.41 0L5.08 14.6zm2.82-4.22L5.8 8.29a1 1 0 00-1.4 0l-2.1 2.1a1 1 0 000 1.42l2.08 2.08 3.52-3.51z",
    fill: primaryFill
  }));
};
export const ToDoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToDoFilledIcon({}), 'ToDoFilled');
const ToDoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.38 13.9l2.8 2.8c.2.2.46.3.72.3a1 1 0 00.7-.3l2.46-2.45L17.7 7.6a1 1 0 000-1.42l-2.1-2.1a1 1 0 00-1.42 0l-6.3 6.3-2.08-2.09a1 1 0 00-1.42 0l-2.1 2.1a1 1 0 000 1.42l2.1 2.08zM7.9 16l-2.1-2.1 9.1-9.11 2.1 2.1-9.1 9.1zm-2.81-2.81L3 11.09 5.1 9l2.09 2.1-2.1 2.1z",
    fill: primaryFill
  }));
};
export const ToDoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToDoRegularIcon({}), 'ToDoRegular');
const VivaColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.53 7.97a3.5 3.5 0 104.94-4.94 3.5 3.5 0 00-4.94 4.94z",
    fill: "#62D0E0"
  }), React.createElement("path", {
    d: "M14 15.99l3.86-4.58c.19-.23.2-.56-.02-.78a5.08 5.08 0 00-7.78.38L6 16c2.24 2.68 5.76 2.68 8 0z",
    fill: "#2B256F"
  }), React.createElement("path", {
    d: "M6 15.99L2.14 11.4a.57.57 0 01.02-.78 5.08 5.08 0 017.78.38L14 16c-2.24 2.68-5.76 2.68-8 0z",
    fill: "#385DC2"
  }));
};
export const VivaColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaColorIcon({}), 'VivaColor');
const VivaFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.47 7.97a3.5 3.5 0 11-4.94-4.94 3.5 3.5 0 014.94 4.94zM2.14 11.41L6 15.99c2.24 2.68 5.76 2.68 8 0L9.94 11a5.08 5.08 0 00-7.78-.38.57.57 0 00-.02.78zm8.57-1.03l3.95 4.83 3.2-3.8c.19-.23.2-.56-.02-.78a5.03 5.03 0 00-7.15-.27l.02.01v.01z",
    fill: primaryFill
  }));
};
export const VivaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaFilledIcon({}), 'VivaFilled');
const VivaRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.47 7.97a3.5 3.5 0 11-4.94-4.94 3.5 3.5 0 014.94 4.94zm-4.24-.7a2.5 2.5 0 103.54-3.54 2.5 2.5 0 00-3.54 3.54zM2.14 11.4a.57.57 0 01.02-.78 5.08 5.08 0 017.78.38l.06.08.06-.08a5.08 5.08 0 017.78-.38c.21.22.2.55.02.78L14 15.99c-2.24 2.68-5.76 2.68-8 0L2.14 11.4zm4.63 3.94A4.22 4.22 0 0010 17c.9 0 1.84-.34 2.66-1.07l-3.5-4.28c-1.66-2-4.18-2.17-6-.59l3.6 4.29zm6.59-.15l3.48-4.14c-1.82-1.58-4.34-1.4-6 .6l-.2.22 2.72 3.32z",
    fill: primaryFill
  }));
};
export const VivaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaRegularIcon({}), 'VivaRegular');
const VivaAmplifyColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.33 14.33a3.67 3.67 0 11-7.33 0 3.67 3.67 0 017.33 0z",
    fill: "#561E60"
  }), React.createElement("path", {
    d: "M5.38 6.65l-2.97 6a2.33 2.33 0 014.16.27l1.84 3.71A2.42 2.42 0 0010.58 18h5.25l-1.09-.46L9.46 7.31a3.12 3.12 0 00-4.08-.66z",
    fill: "#CB6BDF"
  }), React.createElement("path", {
    d: "M12.7 3.8l4.2 8.35c.3.58.84 1.77.84 1.77.15.4.25.85.26 1.33v.33c0 1.34-.99 2.42-2.2 2.42a2.2 2.2 0 01-1.96-1.3L9.5 8.1A2.82 2.82 0 007 6.5c-.76 0-1.45.3-1.95.8L6.8 3.8a3.33 3.33 0 015.92 0z",
    fill: "#894497"
  }));
};
export const VivaAmplifyColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaAmplifyColorIcon({}), 'VivaAmplifyColor');
const VivaAmplifyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 6c-.33 0-.6.02-.84.07l1.11-2.25.02-.03a3.33 3.33 0 015.92 0l4.2 8.36c.3.58.83 1.77.83 1.77.15.4.25.85.26 1.33v.33c0 1.34-.99 2.42-2.2 2.42a2.2 2.2 0 01-1.96-1.3L9.99 9.1C9.29 7.69 8.44 6 6.5 6zM4 11c-.28 0-.57.06-.85.16l1.73-3.51C5.27 7.18 5.73 7 6.5 7c.44 0 1.12.22 1.52.71.4.5.73 1.14 1.08 1.83l3.84 7.6c.15.32.35.6.58.86h-2.94c-.96 0-1.78-.56-2.18-1.37l-1.83-3.7C5.87 11.64 5 11 4 11zm-2 3.33c0-.4.07-.79.19-1.15C2.5 12.5 3 12 4 12c.49 0 1.09.29 1.68 1.39l1.83 3.68c.05.11.11.22.18.32A3.67 3.67 0 012 14.33z",
    fill: primaryFill
  }));
};
export const VivaAmplifyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaAmplifyFilledIcon({}), 'VivaAmplifyFilled');
const VivaAmplifyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.3 12.97c-.13-.3-.28-.6-.4-.82l-4.2-8.36a3.33 3.33 0 00-5.9 0L4.84 7.71l-2.39 4.83-.08.18a3.67 3.67 0 006.07 4c.4.76 1.21 1.28 2.13 1.28h4.63c1.83 0 2.82-1.29 2.79-2.8-.01-.42-.1-.86-.26-1.28l-.43-.95zM13.46 17h-2.87c-.55 0-1.04-.32-1.27-.8l-1.4-3.1C7.48 12.04 6.52 11 5 11c-.24 0-.47.02-.7.08L5.8 8.02 5.83 8v-.01c.45-.77.91-.98 1.54-.98.64 0 1.29.58 1.8 1.53l3.54 7.1.07.15c.2.4.4.84.67 1.22zm-5.48-1.33a2.67 2.67 0 11-4.3-3.1c.43-.4.81-.57 1.33-.57.97 0 1.65.66 2 1.5l.97 2.17zm8.84-1.37c.12.32.18.63.19.92 0 .54-.16.97-.43 1.27-.26.28-.7.51-1.36.51-.35 0-.58-.13-.83-.43a3.39 3.39 0 01-.34-.52l-.36-.72-.07-.14-3.55-7.12v-.01a6 6 0 00-.56-.85c-.16-.21-.34-.4-.53-.56-.28-.24-.6-.44-.97-.55-.2-.07-.4-.1-.63-.1-.19 0-.38.01-.58.05l.9-1.8a2.33 2.33 0 014.13 0L16 12.59v.02a30.56 30.56 0 01.73 1.52l.06.14.01.03zM2.38 12.72l.08-.18z",
    fill: primaryFill
  }));
};
export const VivaAmplifyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaAmplifyRegularIcon({}), 'VivaAmplifyRegular');
const VivaConnectionsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a4 4 0 014-4h6a2 2 0 110 4H8a2 2 0 100 4h6a4 4 0 01-4 4H6a4 4 0 01-4-4v-4z",
    fill: "#0766B6"
  }), React.createElement("path", {
    d: "M18 10a4 4 0 01-4 4H8a2 2 0 110-4h4a2 2 0 100-4H6a4 4 0 014-4h4a4 4 0 014 4v4z",
    fill: "#63CFF3"
  }));
};
export const VivaConnectionsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaConnectionsColorIcon({}), 'VivaConnectionsColor');
const VivaConnectionsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a4 4 0 01-4 4H7.5c-.77 0-1.5-.73-1.5-1.75s.73-1.75 1.5-1.75h5c1.43 0 2.5-1.29 2.5-2.75S13.93 5 12.5 5H6.13A4 4 0 0110 2h4a4 4 0 014 4v4zM6 6a4 4 0 00-4 4v4a4 4 0 004 4h4a4 4 0 003.87-3H7.5C6.07 15 5 13.71 5 12.25S6.07 9.5 7.5 9.5h5c.77 0 1.5-.73 1.5-1.75S13.27 6 12.5 6H6z",
    fill: primaryFill
  }));
};
export const VivaConnectionsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaConnectionsFilledIcon({}), 'VivaConnectionsFilled');
const VivaConnectionsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.87 15H14a4 4 0 004-4V6a4 4 0 00-4-4h-4a4 4 0 00-4 4 4 4 0 00-4 4v4a4 4 0 004 4h4a4 4 0 003.87-3zM3 10a3 3 0 013-3h5.5a1.5 1.5 0 010 3h-3a2.5 2.5 0 100 5h4.33A3 3 0 0110 17H6a3 3 0 01-3-3v-4zm11 4H8.5a1.5 1.5 0 010-3h3a2.5 2.5 0 100-5H7a3 3 0 013-3h4a3 3 0 013 3v5a3 3 0 01-3 3z",
    fill: primaryFill
  }));
};
export const VivaConnectionsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaConnectionsRegularIcon({}), 'VivaConnectionsRegular');
const VivaEngageColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a4 4 0 014 4v5H2V6a4 4 0 014-4z",
    fill: "#0472D8"
  }), React.createElement("path", {
    d: "M14 2a4 4 0 00-4 4v5h8V6a4 4 0 00-4-4z",
    fill: "#2596FF"
  }), React.createElement("path", {
    d: "M14 9a4 4 0 10-8 0 4 4 0 008 0z",
    fill: "#56C5FF"
  }), React.createElement("path", {
    d: "M18 6v-.16C17.88 8.4 15.36 10 13 10a4 4 0 100 8c3.29 0 5-2.67 5-5.75V6z",
    fill: "#0472D8"
  }), React.createElement("path", {
    d: "M2 12.25C2 15.33 3.71 18 7 18a4 4 0 000-8c-2.36 0-4.88-1.61-5-4.16v6.41z",
    fill: "#0C4497"
  }));
};
export const VivaEngageColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaEngageColorIcon({}), 'VivaEngageColor');
const VivaEngageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 2a4 4 0 00-3.48 2.03 5 5 0 014.46 4.58 5.82 5.82 0 002.31-1.32l.71-.7V6a4 4 0 00-4-4zM2 12.25C2 15.33 3.71 18 7 18a4 4 0 000-8 7.4 7.4 0 01-5-2v4.25zm8.78 5.02c.64.42 1.4.67 2.22.67 3.29 0 5-2.67 5-5.75V8a7.58 7.58 0 01-5 1.94c-.85 0-1.64.26-2.28.72a4.98 4.98 0 01.06 6.61zM6 2a4 4 0 013.48 2.03 5 5 0 00-4.47 4.63A6.13 6.13 0 012.7 7.28L2 6.6V6a4 4 0 014-4zm0 6.91a4 4 0 018-.06c-.35.06-.68.09-1 .09-1.14 0-2.2.38-3.04 1.03A4.98 4.98 0 007 9c-.33 0-.66-.03-1-.09z",
    fill: primaryFill
  }));
};
export const VivaEngageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaEngageFilledIcon({}), 'VivaEngageFilled');
const VivaEngageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.48 4.03a5.06 5.06 0 011.04 0A4 4 0 0118 6v6.25c-.07 1.99-1 5.75-5 5.75-1.2 0-2.27-.52-3-1.35A4 4 0 017 18c-4 0-4.93-3.76-5-5.75V6a4 4 0 017.48-1.97zm-1.04.22A3 3 0 003 6v1.68c.52.76 1.22 1.4 2.02 1.82a5 5 0 013.41-5.25zM6.1 9.9c.3.06.6.1.9.1 1.2 0 2.27.52 3 1.35A3.99 3.99 0 0113 10c.3 0 .6-.04.9-.1A4.01 4.01 0 0010 5a4 4 0 00-3.9 4.9zm8.88-.4c.8-.41 1.5-1.06 2.02-1.82V6a3 3 0 00-5.44-1.75 5 5 0 013.42 5.25zM13 17a3.4 3.4 0 003.12-1.66 6.6 6.6 0 00.88-3.12V9.23A5.7 5.7 0 0113 11a3 3 0 00-2.42 1.22 3.98 3.98 0 010 3.56A3 3 0 0013 17zM3 12.1v.12c.03.89.26 2.13.88 3.12A3.4 3.4 0 007 17a3 3 0 100-6 5.7 5.7 0 01-4-1.77v2.88z",
    fill: primaryFill
  }));
};
export const VivaEngageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaEngageRegularIcon({}), 'VivaEngageRegular');
const VivaGlintColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.73 12.2a3.99 3.99 0 004.27-.8l3.18-2.87a1.62 1.62 0 012.6.27 3.74 3.74 0 01-1.06 4.11L12 17.1a3.24 3.24 0 01-5.5-2.35c0-1.03.48-1.95 1.23-2.55z",
    fill: "#6343BF"
  }), React.createElement("path", {
    d: "M7.06 12.35l2.2-2.11c1-.97 1.58-2.21 1.71-3.5l.23-.23a2.5 2.5 0 014.07-.77l1.68 1.62a4.47 4.47 0 01.63.87 3.86 3.86 0 01.42 1.93v-.03a1.63 1.63 0 00-2.82-1.1L12 11.9a3.99 3.99 0 01-4.94.44z",
    fill: "#B05EF3"
  }), React.createElement("path", {
    d: "M18 10.17v0z",
    fill: "#B05EF3"
  }), React.createElement("path", {
    d: "M9.9 2.22a.74.74 0 00-1.04-.02L3.25 7.45l-.11.1h-.01a3.74 3.74 0 00.15 5.51l3.91 3.7a3.24 3.24 0 01.35-4.4l2.22-2.13a5.65 5.65 0 00.14-8z",
    fill: "#CE8BED"
  }));
};
export const VivaGlintColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGlintColorIcon({}), 'VivaGlintColor');
const VivaGlintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.42 8.5c.19-.35.43-.67.71-.94v-.01l.12-.1L8.86 2.2a.74.74 0 011.06.05c.71.74 1.08 1.9 1.08 3.13 0 1.62-.63 3.33-1.74 4.4L7.04 11.9A3.72 3.72 0 006 14.5c0 .27.02.73.12 1.27l-2.97-2.83a3.74 3.74 0 01-.73-4.43zM12 17.1c-.58.56-1.38.9-2.25.9a2.45 2.45 0 01-2.5-1.83A5.62 5.62 0 017 14.5c0-.32.06-.65.17-.95a4.98 4.98 0 005.5-.9l1.6-1.44c.76-.7 1.59-1.21 2.44-1.21.58 0 1.29.47 1.29 1.03 0 .76-.76 1.38-1.28 1.88L12 17.1zm6-7.6c-.32-.31-.85-.5-1.3-.5-1.23 0-2.3.73-3.1 1.47L12 11.9a3.99 3.99 0 01-4.32.77l.05-.04 2.23-2.14a7.24 7.24 0 002.04-5 2.49 2.49 0 013.27.24l1.68 1.62c.55.6.92 1.33 1.05 2.14z",
    fill: primaryFill
  }));
};
export const VivaGlintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGlintFilledIcon({}), 'VivaGlintFilled');
const VivaGlintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.47 5.61a3.34 3.34 0 012.03-.6c1.03 0 1.58.53 2.03.99l1.42 1.36A3.74 3.74 0 0118 10c.01 1.13-.5 2.22-1.29 2.91l-4.72 4.19A3.24 3.24 0 017.4 17l-2.03-1.96-2.1-1.99a3.74 3.74 0 01-.13-5.5l.12-.1L8.86 2.2a.74.74 0 011.04.02 5.62 5.62 0 011.57 3.4zM3.92 8.2l-.1.09a2.74 2.74 0 00.11 4.02l2.1 2a5.46 5.46 0 01-.03-.62 3.2 3.2 0 011.16-2.34L9.07 9.5a4.63 4.63 0 00.29-6.4L3.92 8.19zm4.21 3.6a3 3 0 003.18-.6l2.7-2.41A2.85 2.85 0 0116.2 8l-1.37-1.3c-.43-.44-.73-.7-1.32-.7-.75 0-1.49.2-2.08 1.11a5.62 5.62 0 01-1.66 3.11L8.13 11.8zM17 10c0-.01 0 .01 0 0 0-.39-.19-.73-.5-.89A1.11 1.11 0 0016 9c-.47 0-1 .18-1.3.5L12 11.9a3.99 3.99 0 01-4.6.65c-.22.29-.4.66-.4 1.13 0 .46.06.86.17 1.2.17.55.47.99.91 1.4.5.46 1.05.72 1.65.72.6 0 1.16-.24 1.56-.63h.02l4.73-4.21c.57-.5.96-1.32.96-2.16z",
    fill: primaryFill
  }));
};
export const VivaGlintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGlintRegularIcon({}), 'VivaGlintRegular');
const VivaGoalsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 2h-.75A4.25 4.25 0 0012 6.22V10a5 5 0 01-10 .25 8 8 0 0016-.13V3a1 1 0 00-1-1z",
    fill: "#00554C"
  }), React.createElement("path", {
    d: "M9 8.75a4.25 4.25 0 013.33-4.15c-.2.5-.33 1.05-.33 1.62V10a5 5 0 01-10 .25v.09-.84a3.5 3.5 0 107 0v-.75z",
    fill: "#068576"
  }), React.createElement("circle", {
    cx: 5.5,
    cy: 9.5,
    r: 3.5,
    fill: "#40DCC9"
  }));
};
export const VivaGoalsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGoalsColorIcon({}), 'VivaGoalsColor');
const VivaGoalsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10.12V3a1 1 0 00-1-1h-.75A4.25 4.25 0 0012 6.22V10a5 5 0 01-7.59 4.28c-.5-.28-1.11-.7-1.86-1.36A8 8 0 0018 10.12zm-7-3.9c0-.35.04-.68.1-1A6.32 6.32 0 009 9.75v.75a3.5 3.5 0 01-2.78 3.42A4.02 4.02 0 0011 10V6.22zm-3.18.66c.22.2.41.41.58.66-.26.73-.4 1.5-.4 2.21v.75A2.5 2.5 0 015.6 13h-.1a3.5 3.5 0 112.32-6.12z",
    fill: primaryFill
  }));
};
export const VivaGoalsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGoalsFilledIcon({}), 'VivaGoalsFilled');
const VivaGoalsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6a4 4 0 00-4 4v.11A7.96 7.96 0 0010 18a7.99 7.99 0 008-7.88V3a1 1 0 00-1-1h-.75a4.25 4.25 0 00-3.92 2.6 4.26 4.26 0 00-3.16 2.96A4 4 0 006 6zm6 4.28a5 5 0 01-7.5 4.05c-.23-.3-.44-.61-.63-.94A4 4 0 0010 10V8.75c0-1.36.84-2.53 2.03-3.01l-.03.48v4.06zM9 10a3 3 0 11-6 0 3 3 0 016 0zm.75 7a6.96 6.96 0 01-3.42-1.04A6 6 0 0013 10V6.23A3.25 3.25 0 0116.25 3H17V10.11A7 7 0 019.75 17zM12 10z",
    fill: primaryFill
  }));
};
export const VivaGoalsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGoalsRegularIcon({}), 'VivaGoalsRegular');
const VivaInsightsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.96 10.01A3.52 3.52 0 005.5 6a3.5 3.5 0 102.74 5.68l.01-.02 1.34-1.65h-.63z",
    fill: "#1D3179"
  }), React.createElement("circle", {
    cx: 10.5,
    cy: 6.5,
    r: 4.5,
    fill: "#6CA2FF"
  }), React.createElement("path", {
    d: "M2.9 11.84l4.44 4.94.11.12.05.05a3.49 3.49 0 005.03-.03l4.57-5.08a3.5 3.5 0 10-5.42-4.42l-3.43 4.24-.06.08a3.5 3.5 0 01-5.3.1z",
    fill: "#3B5DB0"
  }));
};
export const VivaInsightsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaInsightsColorIcon({}), 'VivaInsightsColor');
const VivaInsightsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.75 5a4.5 4.5 0 00-8.68.7 4.53 4.53 0 002 4.6l2.83-3.5A4.5 4.5 0 0114.75 5zm.48 1.08a3.51 3.51 0 00-3.54 1.34l-3.43 4.24-.73.85a3.5 3.5 0 01-2.9 1.26l2.72 3 .1.13.05.05a3.5 3.5 0 005.03-.02l4.57-5.09a3.51 3.51 0 00-1.87-5.76zM3.16 12.12a2.49 2.49 0 003.6-.24l.68-.8a5.5 5.5 0 01-2.42-5.05A3.5 3.5 0 003 11.93l.17.2z",
    fill: primaryFill
  }));
};
export const VivaInsightsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaInsightsFilledIcon({}), 'VivaInsightsFilled');
const VivaInsightsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.98 6.03a4.5 4.5 0 00-8.96 0l-.3-.02L5.5 6a3.5 3.5 0 00-2.51 5.94l4.36 4.84.1.12.05.05a3.5 3.5 0 005.03-.02l4.57-5.09a3.51 3.51 0 00-2.12-5.8zm-1.01.01a3.5 3.5 0 00-2.28 1.38L9.68 9.9a3.5 3.5 0 114.29-3.86zM5.28 13l-1.56-1.74A2.5 2.5 0 015.5 7l.24.01.3.05A4.5 4.5 0 009 10.74l-.74.92-.07.08A3.56 3.56 0 015.5 13h-.22zm2.8 3.12l-1.93-2.16a4.42 4.42 0 002.8-1.57l.08-.09 3.45-4.26.01-.01A2.5 2.5 0 0117 9.5a2.5 2.5 0 01-.64 1.67l-4.56 5.07a2.5 2.5 0 01-3.57.03l-.02-.03-.12-.13z",
    fill: primaryFill
  }));
};
export const VivaInsightsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaInsightsRegularIcon({}), 'VivaInsightsRegular');
const VivaLearningColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 18v-.05A2.5 2.5 0 008.5 13h-2A1.5 1.5 0 015 11.5V6a3 3 0 00-3 3v6a3 3 0 003 3h4z",
    fill: "#003951"
  }), React.createElement("path", {
    d: "M11 6v9.5a2.5 2.5 0 01-2 2.45V18h6a3 3 0 003-3V9a3 3 0 00-3-3h-4z",
    fill: "#117898"
  }), React.createElement("path", {
    d: "M11 15.5v-10a3.5 3.5 0 10-7 0v6c0 .83.67 1.5 1.5 1.5h3a2.5 2.5 0 012.5 2.5z",
    fill: "#63D8E1"
  }));
};
export const VivaLearningColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaLearningColorIcon({}), 'VivaLearningColor');
const VivaLearningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6h-4v9.5c0 .98-.4 1.86-1.05 2.5H15a3 3 0 003-3V9a3 3 0 00-3-3zM7.5 18a2.5 2.5 0 100-5h-2A1.5 1.5 0 014 11.5V6.17A3 3 0 002 9v6a3 3 0 003 3h2.5zM10 4.5v8.55A3.49 3.49 0 007.5 12h-2a.5.5 0 01-.5-.5v-7a2.5 2.5 0 115 0z",
    fill: primaryFill
  }));
};
export const VivaLearningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaLearningFilledIcon({}), 'VivaLearningFilled');
const VivaLearningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 6.17A3 3 0 002 9v6a3 3 0 003 3h10a3 3 0 003-3V9a3 3 0 00-3-3h-4v-.5a3.5 3.5 0 10-7 0v.67zM10 15a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 011-1.73v4.23A1.5 1.5 0 005.5 13H8a2 2 0 012 2zm1-8h4a2 2 0 012 2v6a2 2 0 01-2 2h-4.76a3 3 0 00.76-2V7zm-1 5.76A2.99 2.99 0 008 12H5.5a.5.5 0 01-.5-.5v-6a2.5 2.5 0 115 0v7.26z",
    fill: primaryFill
  }));
};
export const VivaLearningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaLearningRegularIcon({}), 'VivaLearningRegular');
const VivaPulseColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.73 10.04l4.62-4.57A2 2 0 009 2a3 3 0 00-2.17.93C5.28 4.38 3.73 5.8 2.23 7.3c-.3.31-.3.8 0 1.11a5.2 5.2 0 003.5 1.62z",
    fill: "#0A828A"
  }), React.createElement("path", {
    d: "M6.78 17.01a3 3 0 004.43.01l5.88-5.86.07-.07v-.01A2.99 2.99 0 0015 6a3 3 0 00-1.1.21 3 3 0 01-.92 3.04l-5.3 5.25A2 2 0 008.91 18 3 3 0 016.78 17z",
    fill: "#0A5768"
  }), React.createElement("path", {
    d: "M9 2c.8 0 1.52.3 2.05.81l2.04 2.02.22.26a2.99 2.99 0 01-.33 4.16l-5.3 5.25A2 2 0 008.91 18 3 3 0 016.78 17l-2.06-2.06-.02-.03a2.99 2.99 0 01.14-4l5.51-5.45A2 2 0 009.01 2z",
    fill: "#18D3DA"
  }));
};
export const VivaPulseColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaPulseColorIcon({}), 'VivaPulseColor');
const VivaPulseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a3 3 0 00-2.17.93C5.28 4.38 3.73 5.8 2.23 7.3c-.3.31-.3.8 0 1.11a4.24 4.24 0 003.12 1.23l5.16-4.97c.3-.28.49-.68.49-1.11C11 2.45 9.96 2 9 2zM7.01 16.44c0-.45.2-.85.5-1.13h.02l6.3-6.13A3.63 3.63 0 0014.95 6a3 3 0 012.21 5.08l-.07.08-5.88 5.86A3 3 0 019 18c-.96 0-1.99-.45-1.99-1.56zm-1 .05L4.6 15.05l-.01-.01a2.49 2.49 0 01.12-3.34l.07-.07L11.2 5.4a2.5 2.5 0 00.8-1.9l1.22 1.24.21.24c.36.43.57.98.57 1.59 0 .73-.32 1.34-.87 1.9l-6.29 6.1a2.5 2.5 0 00-.83 1.92z",
    fill: primaryFill
  }));
};
export const VivaPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaPulseFilledIcon({}), 'VivaPulseFilled');
const VivaPulseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.38 8.57c.71.71 1.58 1.16 2.49 1.36l-.52.5a2.99 2.99 0 00-.14 4l.02.03 2.55 2.55a3 3 0 004.43.01l5.88-5.86.07-.07v-.01A2.99 2.99 0 0015 6a3 3 0 00-1.1.21 3 3 0 00-.59-1.12l-.22-.26-2.03-2.02h-.01l-.02-.02A2.99 2.99 0 009 2H9a3 3 0 00-2.17.93l-2.7 2.52a2.9 2.9 0 00-.33.3L2.23 7.3c-.3.31-.3.8 0 1.11l.15.15zm11.6-1.3a2 2 0 012.45 3.11v.01l-.02.02-.02.03-5.9 5.9h-.01a2 2 0 01-3.37-.68c.1-.77.73-1.44 1.07-1.73l4.8-4.68a3 3 0 001-1.98zM9 3c.4 0 .78.12 1.1.32.65.6.2 1.4-.2 1.77L5.8 9.04a3.98 3.98 0 01-2.71-1.17L4.5 6.45a2.16 2.16 0 01.23-.2l.05-.03 2.75-2.58.02-.02A2 2 0 019 3zm2.36 1.52l1 1 .2.22a1.99 1.99 0 01-.24 2.76l-.02.02-4.8 4.68c-.25.22-.65.61-.96 1.13-.12.2-.23.45-.32.71L4.98 13.8a1.99 1.99 0 01.1-2.68l.04-.04 5.46-5.26c.3-.28.64-.73.78-1.28v-.02z",
    fill: primaryFill
  }));
};
export const VivaPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaPulseRegularIcon({}), 'VivaPulseRegular');
const VivaSalesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.73 2.73A2.5 2.5 0 002 4.5v9a2.5 2.5 0 004.27 1.77l9-9A2.5 2.5 0 0013.5 2h-9a2.5 2.5 0 00-1.77.73z",
    fill: "#02865E"
  }), React.createElement("path", {
    d: "M12.5 18a5.5 5.5 0 100-11 5.5 5.5 0 000 11z",
    fill: "#044A31"
  }), React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 004.5 7h4a2.5 2.5 0 011.77 4.27l-4 4A2.5 2.5 0 012 13.5v-9z",
    fill: "#61D8AC"
  }));
};
export const VivaSalesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaSalesColorIcon({}), 'VivaSalesColor');
const VivaSalesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.73 6.26A2.5 2.5 0 012 4.5v9a2.5 2.5 0 004.27 1.77l4-4A2.5 2.5 0 008.49 7H4.5a2.5 2.5 0 01-1.77-.74zm8.39.91a5.51 5.51 0 11-3.39 8.07l3.25-3.25a3.5 3.5 0 00.14-4.82zM5.25 2C4.01 2 3 3 3 4.25v.25C3 5.33 3.67 6 4.5 6h4c.63 0 1.2.16 1.69.42a6.48 6.48 0 014.84.09l.24-.24A2.5 2.5 0 0013.5 2H5.25z",
    fill: primaryFill
  }));
};
export const VivaSalesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaSalesFilledIcon({}), 'VivaSalesFilled');
const VivaSalesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.24 6.47A2.62 2.62 0 0014.38 2h-9.6A2.79 2.79 0 002 4.79v9.6c0 2.33 2.82 3.5 4.47 1.84l1.17-1.16a5.5 5.5 0 107.43-7.43l1.17-1.17zm-7.85 7.85l2.85-2.85c.98-.98.96-2.4.29-3.36a4.5 4.5 0 11-3.14 6.21zm2.26-7C10.3 7.12 9.86 7 9.38 7H5.01c-1.1 0-2-.9-2-2v-.21C3 3.79 3.8 3 4.78 3h9.6a1.62 1.62 0 011.14 2.77l-1.46 1.46a5.5 5.5 0 00-3.42.09zm-.12 3.45l-4.76 4.76A1.62 1.62 0 013 14.38V7.23A3 3 0 005.01 8h4.37a1.62 1.62 0 011.15 2.77z",
    fill: primaryFill
  }));
};
export const VivaSalesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaSalesRegularIcon({}), 'VivaSalesRegular');
const VivaTopicsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 5,
    fill: "#B26BFF"
  }), React.createElement("path", {
    d: "M13.9 8L11 11l.52 4.14A4 4 0 1013.9 8z",
    fill: "#7655AE"
  }), React.createElement("path", {
    d: "M4.32 8.78L11 11l.52 4.13a5 5 0 11-7.2-6.35z",
    fill: "#3C2B5E"
  }));
};
export const VivaTopicsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaTopicsColorIcon({}), 'VivaTopicsColor');
const VivaTopicsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.38 8.02l-2.86 3.16.45 4.27a4 4 0 102.4-7.43zm-3.36 7.95l-.48-4.58-6.71-2.25a5 5 0 107.2 6.83zM4.14 8.19A5 5 0 1114 6.94l-3.15 3.5-6.7-2.25z",
    fill: primaryFill
  }));
};
export const VivaTopicsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaTopicsFilledIcon({}), 'VivaTopicsFilled');
const VivaTopicsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 8h-.1a5 5 0 10-9.58.77 5 5 0 107.2 6.37A4 4 0 1014 8zm-.52 1.01l.44-.01H14a3 3 0 11-1.86 5.36l-.31-.25-.3-2.94 1.95-2.16zm-2.64 5.24l-.22.46a4 4 0 11-5.76-5.1L5 9.54l5.54 1.85.3 2.87zm2.08-6.45l-.09.43-1.98 2.2-5.53-1.85-.06-.16a4 4 0 117.66-.62z",
    fill: primaryFill
  }));
};
export const VivaTopicsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaTopicsRegularIcon({}), 'VivaTopicsRegular');
const VoteLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M12.23 9h1.27a.5.5 0 010 1h-7a.5.5 0 010-1h.76a1 1 0 01-.13-1.17l2.5-4.33A1 1 0 0111 3.13l2.6 1.5A1 1 0 0113.96 6l-1.73 3zm.87-3.5L10.5 4 8 8.33 9.16 9h1.92l2.02-3.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M13.96 8l.58-1a1 1 0 01.76.4l2.5 3.33a1 1 0 01.12.2 4.98 4.98 0 00-1.83-.81L14.5 8h-.54z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 11H3.25L5.5 8h.4a1 1 0 01.08-.17L6.46 7H5.5a1 1 0 00-.8.4l-2.5 3.33a1 1 0 00-.2.6V16a1 1 0 001 1h7v-2a5 5 0 012-4z",
    fill: primaryFill
  }));
};
export const VoteLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VoteLoopFilledIcon({}), 'VoteLoopFilled');
const WalletColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3H12a2 2 0 012 2v1a2 2 0 01-2 2H4.5A2.5 2.5 0 012 5.5z",
    fill: "url(#paint0_linear_64947_5606)"
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3H12a2 2 0 012 2v1a2 2 0 01-2 2H4.5A2.5 2.5 0 012 5.5z",
    fill: "url(#paint1_radial_64947_5606)"
  }), React.createElement("path", {
    d: "M3.73 8.58c-.47-.8-.2-1.83.61-2.3l8.76-5.05c.8-.47 1.84-.2 2.3.61l3.37 5.84c.47.8.2 1.84-.61 2.3L9.4 15.04c-.8.47-1.84.19-2.3-.62L3.73 8.58z",
    fill: "url(#paint2_linear_64947_5606)"
  }), React.createElement("path", {
    d: "M3.73 8.58c-.47-.8-.2-1.83.61-2.3l8.76-5.05c.8-.47 1.84-.2 2.3.61l3.37 5.84c.47.8.2 1.84-.61 2.3L9.4 15.04c-.8.47-1.84.19-2.3-.62L3.73 8.58z",
    fill: "url(#paint3_radial_64947_5606)"
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 004.5 8H16a2 2 0 012 2v6a2 2 0 01-2 2H6a4 4 0 01-4-4V5.5z",
    fill: "url(#paint4_linear_64947_5606)"
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 004.5 8H16a2 2 0 012 2v6a2 2 0 01-2 2H6a4 4 0 01-4-4V5.5z",
    fill: "url(#paint5_radial_64947_5606)"
  }), React.createElement("path", {
    d: "M12 11.56c0-.3.25-.56.56-.56h1.88c.3 0 .56.25.56.56v1.88c0 .3-.25.56-.56.56h-1.88a.56.56 0 01-.56-.56v-1.88z",
    fill: "#1A43BC"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_64947_5606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-14.2012 0 0 -5.4375 16.2 5.5)"
  }, React.createElement("stop", {
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_64947_5606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.5 .1426 -.02494 2.53619 3.5 8.5)"
  }, React.createElement("stop", {
    offset: 0.45,
    stopColor: "#B91CBF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B91CBF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_64947_5606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-8.47486 2.67016 -3.16054 -10.03128 18.55 11)"
  }, React.createElement("stop", {
    stopColor: "#AD7DFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7DFF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_64947_5606",
    x1: 15.63,
    y1: 5.5,
    x2: 2,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 0.75,
    stopColor: "#004099"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_64947_5606",
    x1: 16.2,
    y1: 1,
    x2: 5.69,
    y2: 7.13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#EF91F3"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E656EB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C543FE"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_64947_5606",
    x1: 18.26,
    y1: 12.87,
    x2: 1.9,
    y2: 12.87,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2764E7"
  }), React.createElement("stop", {
    offset: 0.72,
    stopColor: "#367AF2"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0091EB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33B1FF"
  }))));
};
export const WalletColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/WalletColorIcon({}), 'WalletColor');